<template>
  <ServiceUnavailable
    v-if="serviceUnavailable"
    :message="serviceUnavailableMessage"
    :retrying="retrying"
    :next-retry-seconds="nextRetrySeconds"
    @retry="handleRetry"
    @back="handleBack"
  />
  <div v-else style="position: relative;">
    <!-- <el-button
        style="position: fixed; right: 16px; top: 12px; z-index: 9999;"
        size="small"
        @click="simulateWaPush"
        v-if="isDev"
    >模拟推送</el-button> -->
    <ChatWindow
        style="height: calc(100vh - 48px) !important;"
        ref="chatComponent"
        :current-user-id="currentUserId"
        :loading-rooms="loadingRooms"
        :room-id="activeRoomId"
        :rooms-loaded="roomsLoaded"
        :messages-loaded="messagesLoaded"
        :message-actions="messageActions"
        :message-selection-actions="messageSelectionActions"
        :rooms="displayRooms"
        :messages="messages"
        :room-actions="roomActions"
        :show-emojis="true"
        :show-reaction-emojis="false"
        :show-files="true"
        :show-audio="true"
        :show-search="true"
        :show-add-room="true"
        :auto-scroll="true"
        :load-first-room="false"
        @add-room="addRoom"
        @refresh="handleRefresh"
        @sync-finished="handleSyncFinished"
        @fetch-messages="fetchMessages"
        @send-message="sendMessage"
        @send-voice="sendVoice"
        @send-message-reaction="handleMessageReaction"
        @typing-message="handleTypingMessage"
        @delete-message="deleteMessage"
        @edit-message="editMessage"
        @forward-message="handleForwardMessage"
        @room-action-handler="roomActionHandler"
        @room-menu-open="handleRoomMenuOpen"
        @archive-success="handleArchiveSuccess"
        @close-room="handleCloseRoom"
        @fetch-more-rooms="fetchMoreRooms"
    />
    <DeleteChatConfirm ref="deleteChatConfirm" @confirm="handleDeleteRoom"/>
    <ClearChatConfirm ref="clearChatConfirm" @confirm="handleClearChat"/>
    <LeaveGroupConfirm ref="leaveGroupConfirm" @confirm="handleLeaveGroup"/>
  </div>
</template>

<script>
import ChatWindow from "@/modules/whatsapp/lib/index";
import {formatChatTime} from "@/modules/whatsapp/utils/wa-index";
import ReturnEmails from "@/components/DiaPops/Returns/ReturnEmails.vue";
import DeleteChatConfirm from "@/views/WhatsApp/Compontents/DeleteChatConfirm.vue";
import ClearChatConfirm from "@/views/WhatsApp/Compontents/ClearChatConfirm.vue";
import LeaveGroupConfirm from "@/views/WhatsApp/Compontents/LeaveGroupConfirm.vue";
import { showWhatsAppNotify } from "@/utils/notifies";
import ServiceUnavailable from "@/views/WhatsApp/Compontents/ServiceUnavailable.vue";
import {
  createWhatsAppQr,
  getUserInfoBySession,
  getAllMessage,
  getMessageByChatId,
  getMessageByChatIdAndMessageId,
  topMessageByMessageId,
  unTopMessageByMessageId,
  forwardMessage,
  sendButtonsReply,
  sendReaction,
  sendFile,
  sendImage,
  sendText,
  startTyping,
  stopTyping,
  getAllContact,
  deleteMessageByMessageId,
  updateMessageByMessageId,
  deleteAllMessageByChatId,
  leaveGroup,
  getUsByLid,
  getLidAndUsByPhone,
  getContactInfoByContactId,
  sendLinkCustomPreview,
  addWhatsAppExtend
} from '@/api/whatsapp'
import {Storage} from "@/utils/storage";
import {uploadFile as uploadFileToOss} from '@/utils/file'
import loadingObj from '@/utils/index'
import { loadingConfig } from '@/utils/loading'

import defaultGroupAvatar from '@/modules/whatsapp/img/default_group_avatar.svg'
const WA_JID_MAP_STORAGE_KEY = 'wa_jid_map'
// 生成单聊房间ID
const genRoomId = (uid1, uid2) => [uid1, uid2].sort().join("-");
const normalizeWaId = (v) => {
  const s = String(v || '').trim()
  if (!s) return ''
  if (s.includes('@g.us')) return ''
  return s.replace(/@.*$/, '')
}
const mapMessage = (message) => ({
  _id: message.id,
  content: message.content,
  senderId: message.senderId,
  timestamp: message.timestamp,
  ...formatChatTime(message.timestamp),
  saved: message.saved,
  distributed: message.distributed,
  seen: message.seen,
  deleted: message.deleted,
});

export default {
  components: {ReturnEmails, ChatWindow, DeleteChatConfirm, ClearChatConfirm, LeaveGroupConfirm, ServiceUnavailable},
  watch: {
    activeRoomId: {
      handler(val) {
        try {
          window.__waActiveRoomId = String(val || '')
        } catch (e) {
        }
      },
      immediate: true
    }
  },
  beforeUnmount() {
    this.clearAllTypingTimers()

    try {
      if (this._userInteractHandler) {
        window.removeEventListener('mousedown', this._userInteractHandler)
        window.removeEventListener('keydown', this._userInteractHandler)
        window.removeEventListener('touchstart', this._userInteractHandler)
      }
    } catch (e) {
    }

    try {
      window.removeEventListener('wa-push-message', this.handleWaPushMessage)
    } catch (e) {
    }
    try {
      window.removeEventListener('wa-service-unavailable', this.handleWaServiceUnavailable)
    } catch (e) {
    }
    try {
      window.removeEventListener('wa-open-chat', this.handleWaOpenChat)
    } catch (e) {
    }
    if (this.pendingSeenTimer) {
      clearTimeout(this.pendingSeenTimer)
      this.pendingSeenTimer = null
    }

    try {
      window.__waActiveRoomId = ''
    } catch (e) {
    }

    this.stopAutoRetry()
  },
  computed: {
    displayRooms() {
      // 临时 room 需要参与 Room 组件渲染（否则输入框/头部拿不到 room 信息），
      // 但会在 RoomsList 中被过滤掉，不会出现在 room-list。
      return this.tempRoom ? [...(this.rooms || []), this.tempRoom] : (this.rooms || [])
    }
  },
  data() {
    return {
      isDev: process.env.NODE_ENV === 'development',
      dialogVisible: false,
      activeRoomId: "",
      tempRoom: null,
      currentUserId: "100000000000",
      loadingRooms: false,
      roomsLoaded: false,
      messagesLoaded: true,

      contactInfoCacheByRoomId: {},

      // 🔥 按设计稿结构构造房间列表（时间倒序 + 分组）
      rooms: [
        // {
        //   roomId: genRoomId("100000000000", "141341412341"),
        //   roomName: "Clyde Chapman",
        //   avatar: "https://picsum.photos/200/200?random=1", // 正常头像
        //   unreadCount: 0,
        //   type: "single",
        //   lastMessage: {
        //     _id: "msg_20250925",
        //     content: "公司要为员工创造环境，但员工但事实上员工但事实…",
        //     senderId: "141341412341",
        //     timestamp: new Date().getTime(), // 2025-06-25
        //     ...formatChatTime(new Date(2025, 8, 25).getTime()),
        //     saved: true,
        //     distributed: true,
        //     seen: true,
        //     deleted: false,
        //   },
        //   users: [
        //     {_id: "100000000000", username: "我", status: {state: "online"}},
        //     {_id: "141341412341", username: "Clyde Chapman", status: {state: "online"}},
        //   ],
        //   location: "香港",
        //   workingHours: "9时",
        //   isPinned: true, // 置顶标记（设计稿中的蓝色「我的客户」）
        //   isSpecial: true, // 特别关注标记
        // },
        // {
        //   roomId: genRoomId("100000000000", "141341412342"),
        //   roomName: "Clyde Chapman",
        //   avatar: "https://picsum.photos/200/200?random=2",
        //   unreadCount: 0,
        //   type: "single",
        //   lastMessage: {
        //     _id: "msg_20250625",
        //     content: "公司要为员工创造环境，但员工但事实上员工但事实…",
        //     senderId: "141341412342",
        //     timestamp: new Date(2025, 5, 25).getTime(), // 2025-06-25
        //     ...formatChatTime(new Date(2025, 5, 25).getTime()),
        //     saved: true,
        //     distributed: true,
        //     seen: true,
        //     deleted: false,
        //   },
        //   users: [
        //     {_id: "100000000000", username: "我"},
        //     {_id: "141341412342", username: "Clyde Chapman", status: {state: "offline"}},
        //   ],
        //   location: "香港",
        //   workingHours: "9时",
        //   isPinned: false,
        //   isSpecial: false,
        // },
        // {
        //   roomId: genRoomId("100000000000", "141341412343"),
        //   roomName: "Clyde Chapman",
        //   avatar: "https://picsum.photos/200/200?random=3",
        //   unreadCount: 0,
        //   type: "single",
        //   lastMessage: {
        //     _id: "msg_20250225",
        //     content: "公司要为员工创造环境，但员工但事实上员工但事实…",
        //     senderId: "141341412343",
        //     timestamp: new Date(2025, 1, 25).getTime(), // 2025-02-25
        //     ...formatChatTime(new Date(2025, 1, 25).getTime()),
        //     saved: true, //消息成功发送
        //     distributed: true, //消息是否送达
        //     seen: true, //消息是否已读
        //     deleted: false, //消息是否删除/撤回
        //   },
        //   users: [
        //     {_id: "100000000000", username: "我"},
        //     {_id: "141341412343", username: "Clyde Chapman", status: {state: "offline"}},
        //   ],
        //   location: "香港",
        //   workingHours: "9时",
        //   isPinned: false,
        //   isSpecial: false,
        // },
        // {
        //   roomId: genRoomId("100000000000", "141341412344"),
        //   roomName: "Clyde Chapman",
        //   avatar: "", // 灰色占位头像
        //   unreadCount: 0,
        //   type: "single",
        //   lastMessage: {
        //     _id: "msg_20250225_2",
        //     content: "公司要为员工创造环境，但员工但事实上员工但事实…",
        //     senderId: "141341412344",
        //     timestamp: new Date(2025, 1, 25).getTime(), // 2025-02-25
        //     ...formatChatTime(new Date(2025, 1, 25).getTime()),
        //     saved: true,
        //     distributed: true,
        //     seen: true,
        //     deleted: false,
        //   },
        //   users: [
        //     {_id: "100000000000", username: "我"},
        //     {_id: "141341412343", username: "sdfssdf", status: {state: "offline"}},
        //     {_id: "141341412344", username: "Clyde Chapman", status: {state: "offline"}},
        //   ],
        //   location: "香港",
        //   workingHours: "9时",
        //   isPinned: false,
        //   isSpecial: false,
        // },
        // {
        //   roomId: genRoomId("100000000000", "group01"),
        //   roomName: "群聊",
        //   avatar: "", // 灰色占位头像
        //   unreadCount: 0,
        //   type: "group",
        //   lastMessage: {
        //     _id: "msg_20250125",
        //     content: "公司要为员工创造环境，但员工但事实上员工但事实…",
        //     senderId: "group01",
        //     timestamp: new Date(2025, 0, 25).getTime(), // 2025-01-25
        //     ...formatChatTime(new Date(2025, 0, 25).getTime()),
        //     saved: true,
        //     distributed: true,
        //     seen: true,
        //     deleted: false,
        //   },
        //   users: [
        //     {_id: "100000000000", username: "我"},
        //     {_id: "141341412345", username: "群成员1"},
        //     {_id: "141341412346", username: "群成员2"},
        //   ],
        //   location: "",
        //   workingHours: "",
        //   isPinned: false,
        //   isSpecial: false,
        // },
      ],

      messages: [],

      // 缓存已加载/已发送的消息，用于根据 replyTo 还原 replyMessage（跨分页/刷新）
      messageIndex: {},

      pendingSeen: {},
      pendingSeenTimer: null,
      sendingSeen: false,

      // 🔥 按设计稿菜单配置：归档对话 / 置顶对话 / 标记记录 / 特别关注 / 删除对话
      roomActions: [
        {name: "archive", title: "归档对话", disabled: (room) => !!room?.contactInfo?.isMyCustomer},
        // {name: "pin", title: "置顶对话"},
        // {name: "mark", title: "标记未读"},
        // {name: "special", title: "特别关注"},
        // {name: "clearChat", title: "清空聊天"},
        // {name: "delete", title: "删除对话"},
      ],

      messageActions: [
        // {name: "replyMessage", title: "回复"},
        {name: "copyMessage", title: "复制"},
        // {name: "editMessage", title: "编辑", onlyMe: true},
        // {name: "selectMessages", title: "转发"},
        {name: "deleteMessage", title: "删除", onlyMe: true},
      ],

      // 🔥 批量消息选择后的操作（新增）
      messageSelectionActions: [
        {name: 'forwardSelected', title: '转发选中的消息'}, // 批量转发
        // {name: 'deleteSelected', title: '删除选中的消息'}, // 批量删除
        // {name: 'markAsRead', title: '标为已读'} // 可选
      ],

      // 分页状态
      roomsPagination: {
        offset: 1,
        limit: 15,
        chatId: '',
        sortBy: "conversationTimestamp",
        sortOrder:"desc"
      },
      roomsTotal: 0,
      roomsHasMore: true,
      loadingMoreRooms: false,

      // 消息分页状态（用于上滑加载更多历史记录）
      messagesPagination: {
        chatId: '',
        downloadMedia: true,
        filterAck: '',
        // 是否过滤只看自己发送的消息。默认不启用过滤（按后端入参约定：不传/空字符串表示不过滤）
        filterFromMe: '',
        // 每次加载条数：建议 > 0 才能实现上滑分页
        limit: 20,
        merge: true,
        messageId: '',
        offset: 1,
        sortBy: '',
        sortOrder: 'desc'
      },
      loadingMoreMessages: false,
      clearingChat: false,
      leavingGroup: false,
      typingTimers: {},
      typingStates: {},
      typingLastStartAt: {},

      validatingSingleChat: false,

      serviceUnavailable: false,
      serviceUnavailableMessage: '',
      retrying: false,
      apiFailCount: 0,
      API_FAIL_THRESHOLD: 2,

      nextRetrySeconds: 0,
      _autoRetryIndex: 0,
      _autoRetryTimer: null,
      _autoRetryCountdownTimer: null,

      // temp single chat resolve helpers
      _tempRoomResolveToken: 0,
      _tempRoomLastKnownChatId: '',

      _initPagePromise: null,
      _initPageReady: false,
      _pendingOpenChatId: '',

      _hasUserInteracted: false,
      _userInteractHandler: null
    };
  },

  mounted() {
    try {
      this._userInteractHandler = () => {
        this._hasUserInteracted = true
        try {
          window.removeEventListener('mousedown', this._userInteractHandler)
          window.removeEventListener('keydown', this._userInteractHandler)
          window.removeEventListener('touchstart', this._userInteractHandler)
        } catch (e) {
        }
      }
      window.addEventListener('mousedown', this._userInteractHandler)
      window.addEventListener('keydown', this._userInteractHandler)
      window.addEventListener('touchstart', this._userInteractHandler)
    } catch (e) {
    }

    try {
      window.addEventListener('wa-push-message', this.handleWaPushMessage)
    } catch (e) {
    }
    try {
      window.addEventListener('wa-service-unavailable', this.handleWaServiceUnavailable)
    } catch (e) {
    }
    try {
      window.addEventListener('wa-open-chat', this.handleWaOpenChat)
    } catch (e) {
    }
    try {
      window.__waActiveRoomId = String(this.activeRoomId || '')
    } catch (e) {
    }

    // load persisted lid<->pn mapping cache
    try {
      const cached = Storage.get(WA_JID_MAP_STORAGE_KEY)
      const lidToPn = cached?.lidToPn && typeof cached.lidToPn === 'object' ? cached.lidToPn : {}
      const pnToLid = cached?.pnToLid && typeof cached.pnToLid === 'object' ? cached.pnToLid : {}
      this.waJidMap = { lidToPn, pnToLid }
    } catch (e) {
      this.waJidMap = { lidToPn: {}, pnToLid: {} }
    }

    this._initPagePromise = Promise.resolve()
      .then(() => this.initPage())
      .finally(() => {
        this._initPageReady = true
        const pending = String(this._pendingOpenChatId || '').trim()
        this._pendingOpenChatId = ''
        if (pending) {
          this.openChatByChatIdWithLoading(pending)
        }
      })
  },

  methods: {
    computeUnreadTotal() {
      try {
        return (this.rooms || []).reduce((sum, r) => sum + Number(r?.unreadCount || 0), 0)
      } catch (e) {
        return 0
      }
    },

    emitUnreadTotal() {
      try {
        const total = this.computeUnreadTotal()
        window.dispatchEvent(new CustomEvent('wa-unread-total', { detail: { total } }))
      } catch (e) {
      }
    },

    readWaUnreadCache() {
      try {
        const raw = localStorage.getItem('wa_unread_map')
        const parsed = raw ? JSON.parse(raw) : {}
        return parsed && typeof parsed === 'object' ? parsed : {}
      } catch (e) {
        return {}
      }
    },

    writeWaUnreadCache(cache) {
      try {
        localStorage.setItem('wa_unread_map', JSON.stringify(cache || {}))
      } catch (e) {
      }
    },

    handleRoomMenuOpen(payload) {
      try {
        const rid = String(payload?.roomId || '').trim()
        if (!rid) return
        // 仅打开列表行菜单时，不应该把右侧抽屉“带出来”（例如上一条会话曾经打开过抽屉）
        try {
          this.$refs.chatComponent?.closeDrawer?.()
        } catch (e) {
        }
        // 点击每行右侧菜单（vac-list-room-options）时，自动切换选中的 room
        try {
          if (String(this.activeRoomId || '') !== rid) {
            this.activeRoomId = rid
          }
        } catch (e) {
        }
        try {
          this.$refs.chatComponent?.ensureRoomContext?.(rid)
        } catch (e) {
        }
        const isGroup = rid.includes('@g.us')
        if (isGroup) return
        if (this.contactInfoCacheByRoomId?.[rid]) {
          this.applyContactInfoToRoom(rid, this.contactInfoCacheByRoomId[rid])
          return
        }
        const from = this.normalizeFromUsId(this.currentUserId)
        getContactInfoByContactId({ contactId: rid, from })
          .then((r2) => {
            const info = r2?.result || r2?.data?.result || null
            if (!info) return
            this.contactInfoCacheByRoomId = {
              ...(this.contactInfoCacheByRoomId || {}),
              [rid]: info
            }
            this.applyContactInfoToRoom(rid, info)
          })
          .catch(() => {
          })
      } catch (e) {
      }
    },
    handleArchiveSuccess(payload) {
      try {
        const rid = String(payload?.roomId || this.activeRoomId || '').trim()
        if (!rid) return
        const isGroup = rid.includes('@g.us')
        if (isGroup) return
        const from = this.normalizeFromUsId(this.currentUserId)
        getContactInfoByContactId({ contactId: rid, from })
          .then((r2) => {
            const info = r2?.result || r2?.data?.result || null
            if (!info) return
            this.contactInfoCacheByRoomId = {
              ...(this.contactInfoCacheByRoomId || {}),
              [rid]: info
            }
            if (String(this.activeRoomId || '') !== String(rid || '')) return
            this.applyContactInfoToRoom(rid, info)
          })
          .catch(() => {
          })
      } catch (e) {
      }
    },
    applyContactInfoToRoom(roomId, info) {
      if (!roomId) return

      try {
        const patchRoom = (r) => {
          if (!r || String(r.roomId || '') !== roomId) return r
          return {
            ...r,
            contactInfo: info
          }
        }

        if (Array.isArray(this.rooms) && this.rooms.length) {
          this.rooms = this.rooms.map(patchRoom)
        }
        if (this.tempRoom && String(this.tempRoom?.roomId || '') === roomId) {
          this.tempRoom = patchRoom(this.tempRoom)
        }
        try {
          // 当前 ChatWindow 内部 room 对象可能不是 rooms 数组同一个引用，强制同步一次
          if (String(this.activeRoomId || '') === String(roomId || '') && this.$refs.chatComponent) {
            const chat = this.$refs.chatComponent
            if (chat.room && String(chat.room.roomId || '') === String(roomId || '')) {
              chat.room = patchRoom(chat.room)
            }
          }
        } catch (e) {
        }
      } catch (e) {
      }
    },
    normalizeFromUsId(value) {
      const s = String(value || '').trim()
      if (!s) return ''
      if (s.endsWith('@c.us')) return s
      const m = s.match(/^(\d+)/)
      if (m && m[1]) return `${m[1]}@c.us`
      return s
    },
    normalizeJid(jid, preferSuffix) {
      const s = String(jid || '').trim()
      if (!s) return ''
      if (s.includes('@')) return s
      if (preferSuffix) return `${s}${preferSuffix.startsWith('@') ? '' : '@'}${preferSuffix.replace(/^@/, '')}`
      return s
    },

    persistWaJidMap() {
      try {
        Storage.set(WA_JID_MAP_STORAGE_KEY, this.waJidMap || { lidToPn: {}, pnToLid: {} })
      } catch (e) {
      }
    },

    upsertWaJidPair({ lid, pn }) {
      const lidJid = this.normalizeJid(lid)
      const pnJid = this.normalizeJid(pn)
      if (!lidJid || !pnJid) return
      if (!this.waJidMap) this.waJidMap = { lidToPn: {}, pnToLid: {} }
      if (!this.waJidMap.lidToPn) this.waJidMap.lidToPn = {}
      if (!this.waJidMap.pnToLid) this.waJidMap.pnToLid = {}

      this.waJidMap.lidToPn[lidJid] = pnJid
      this.waJidMap.pnToLid[pnJid] = lidJid
      this.persistWaJidMap()
    },

    getPnByLidCached(lid) {
      const lidJid = this.normalizeJid(lid)
      if (!lidJid) return ''
      return String(this.waJidMap?.lidToPn?.[lidJid] || '')
    },

    getLidPnByPhoneCached(phone) {
      const raw = String(phone || '').trim()
      if (!raw) return { lid: '', pn: '' }
      const normalized = normalizeWaId(raw) || raw
      const pn = normalized.includes('@') ? normalized : `${normalized}@c.us`
      const lid = String(this.waJidMap?.pnToLid?.[pn] || '')
      return {
        lid: lid || '',
        pn
      }
    },

    async ensurePnByLid(lid) {
      const lidJid = this.normalizeJid(lid)
      if (!lidJid) return ''
      const cached = this.getPnByLidCached(lidJid)
      if (cached) return cached
      if (typeof getUsByLid !== 'function') return ''

      try {
        const res = await getUsByLid({ lid: lidJid })
        const result = res?.result || res?.data?.result || null
        const pn = result?.pn || ''
        if (pn) {
          this.upsertWaJidPair({ lid: lidJid, pn })
          return this.normalizeJid(pn)
        }
      } catch (e) {
      }
      return ''
    },
    isAuthIssue(err) {
      try {
        const status = err?.response?.status
        if (status === 401 || status === 403) return true
      } catch (e) {
      }

      const msg = String(
        err?.response?.data?.message ||
        err?.response?.data?.msg ||
        err?.message ||
        err ||
        ''
      )

      if (!msg) return false
      if (msg.includes('Token失效')) return true
      if (msg.includes('未登录')) return true
      if (msg.toLowerCase().includes('unauthorized')) return true
      if (msg.toLowerCase().includes('forbidden')) return true
      return false
    },

    gotoWaLogin() {
      this.stopAutoRetry()
      this.retrying = false
      this.serviceUnavailable = false
      this.serviceUnavailableMessage = ''
      try {
        this.$router?.replace?.('/whatsapp/walogin')
      } catch (e) {
      }
    },

    stopAutoRetry() {
      if (this._autoRetryTimer) {
        clearTimeout(this._autoRetryTimer)
        this._autoRetryTimer = null
      }
      if (this._autoRetryCountdownTimer) {
        clearInterval(this._autoRetryCountdownTimer)
        this._autoRetryCountdownTimer = null
      }
      this.nextRetrySeconds = 0
    },

    scheduleAutoRetry() {
      if (!this.serviceUnavailable) return
      if (this.retrying) return
      if (this._autoRetryTimer || this._autoRetryCountdownTimer) return

      const steps = [2, 5, 10, 20, 30]
      const idx = Math.min(Number(this._autoRetryIndex || 0), steps.length - 1)
      const waitSeconds = steps[idx]
      this.nextRetrySeconds = waitSeconds

      this._autoRetryCountdownTimer = setInterval(() => {
        if (!this.serviceUnavailable || this.retrying) {
          this.stopAutoRetry()
          return
        }
        if (this.nextRetrySeconds > 0) {
          this.nextRetrySeconds -= 1
        }
      }, 1000)

      this._autoRetryTimer = setTimeout(() => {
        this._autoRetryTimer = null
        this.stopAutoRetry()
        this._autoRetryIndex = Math.min(Number(this._autoRetryIndex || 0) + 1, steps.length - 1)
        if (!this.serviceUnavailable || this.retrying) return
        this.handleRetry()
      }, waitSeconds * 1000)
    },

    handleWaServiceUnavailable(evt) {
      const detail = evt?.detail || {}
      const msg = String(detail?.message || '服务暂不可用，请稍后重试')
      if (this.isAuthIssue(msg)) {
        this.gotoWaLogin()
        return
      }
      this.markApiFail({message: msg}, msg)
    },
    resetServiceUnavailable() {
      this.apiFailCount = 0
      this.serviceUnavailable = false
      this.serviceUnavailableMessage = ''

      this._autoRetryIndex = 0
      this.stopAutoRetry()
    },

    markApiFail(err, fallbackMessage) {
      if (this.isAuthIssue(err)) {
        this.gotoWaLogin()
        return
      }
      this.apiFailCount += 1
      if (this.apiFailCount >= this.API_FAIL_THRESHOLD) {
        this.serviceUnavailable = true
        this.serviceUnavailableMessage = String(err?.message || fallbackMessage || '接口请求失败或服务维护中，请稍后再试。')
        this.retrying = false

        this.scheduleAutoRetry()
      }
    },

    handleRetry() {
      if (this.retrying) return
      this.retrying = true
      this.apiFailCount = 0
      this.serviceUnavailable = true
      this.serviceUnavailableMessage = ''

      this.stopAutoRetry()
      Promise.resolve()
        .then(() => this.initPage())
        .finally(() => {
          this.retrying = false
          if (this.serviceUnavailable) {
            this.scheduleAutoRetry()
          }
        })
    },

    handleBack() {
      try {
        this.$router?.back?.()
      } catch (e) {
        this.$router?.replace?.('/')
      }
    },
    simulateWaPush() {
      const chatId = String(this.activeRoomId || '')
      if (!chatId) {
        this.$message?.warning?.('请先选择一个对话')
        return
      }
      const messageId = window.prompt('请输入 messageId（用于调用 getMessageByChatIdAndMessageId）', '')
      if (!messageId) return

      const payload = {
        messageType: 'whatsApp',
        message: '[模拟推送]',
        event: 'message',
        userId: String(this.currentUserId || ''),
        chatId,
        messageId
      }

      try {
        showWhatsAppNotify(1, payload, () => {
          try {
            this.$router?.push?.('/whatsapp/wahome')
          } catch (e) {
          }
        })
      } catch (e) {
      }

      try {
        window.dispatchEvent(new CustomEvent('wa-push-message', {detail: payload}))
      } catch (e) {
      }
    },

    handleWaOpenChat(evt) {
      const detail = evt?.detail || {}
      const chatId = String(detail?.chatId || '')
      if (!chatId) return

      if (!this._initPageReady) {
        this._pendingOpenChatId = chatId
        if (!this._initPagePromise) {
          this._initPagePromise = Promise.resolve()
            .then(() => this.initPage())
            .finally(() => {
              this._initPageReady = true
              const pending = String(this._pendingOpenChatId || '').trim()
              this._pendingOpenChatId = ''
              if (pending) {
                this.openChatByChatIdWithLoading(pending)
              }
            })
        }
        return
      }

      this.openChatByChatIdWithLoading(chatId)
    },

    async openChatByChatIdWithLoading(chatId) {
      try {
        loadingObj?.loadingShow?.({
          ...(loadingConfig || {}),
          text: '加载中...'
        })
      } catch (e) {
      }

      try {
        await this.openChatByChatId(chatId)
      } finally {
        try {
          loadingObj?.loadingHide?.()
        } catch (e) {
        }
      }
    },

    async openChatByChatId(chatId) {
      const cid = String(chatId || '').trim()
      if (!cid) return

      const candidateChatIds = this.buildPushChatIdCandidates(cid)
      let room = this.findRoomByAnyChatId(candidateChatIds)

      if (!room) {
        try {
          room = await this.tryFindRoomByLoadingMore(candidateChatIds)
        } catch (e) {
        }
      }

      if (!room) {
        try {
          room = await this.tryResolveExistingRoomByRemote(candidateChatIds)
        } catch (e) {
        }
      }

      if (!room) {
        try {
          room = this.ensureRoomForPushChatId({chatId: cid, candidateChatIds})
        } catch (e) {
          room = null
        }
      }

      if (!room) return

      this.tempRoom = null
      if (String(this.activeRoomId || '') !== String(room.roomId || '')) {
        this.activeRoomId = room.roomId
      }

      try {
        await this.fetchMessages({ room, options: { reset: true } })
      } catch (e) {
      }
    },

    async handleWaPushMessage(evt) {
      const payload = evt?.detail || {}
      const chatId = String(payload.chatId || '')
      const rawChatId = String(payload.rawChatId || '')
      const rawFrom = String(payload.rawFrom || '')
      const messageId = String(payload.messageId || '')
      if (!chatId || !messageId) return

      // WS payload uses lid in `from`, but room-list might use pn (@c.us).
      // Resolve lid -> pn early to improve room matching.
      const fromJid = String(payload.from || '')
      if (fromJid && fromJid.endsWith('@lid')) {
        await this.ensurePnByLid(fromJid)
      }

      // Some WS payloads use lid directly as chatId
      if (chatId && chatId.endsWith('@lid')) {
        await this.ensurePnByLid(chatId)
      }

      // Warm up mapping with raw fields as well (Hooks may have mapped them already)
      if (rawFrom && rawFrom.endsWith('@lid')) {
        await this.ensurePnByLid(rawFrom)
      }
      if (rawChatId && rawChatId.endsWith('@lid')) {
        await this.ensurePnByLid(rawChatId)
      }

      if (process.env.NODE_ENV === 'development') {
        try {
          console.log('[WA-PUSH] received', { chatId, messageId, payload })
        } catch (e) {
        }
      }

      const candidateChatIds = Array.from(new Set([
        ...this.buildPushChatIdCandidates(chatId),
        ...(rawChatId ? this.buildPushChatIdCandidates(rawChatId) : [])
      ]))
      const matchedRoom = this.findRoomByAnyChatId(candidateChatIds)
      const activeMatched = candidateChatIds.some((id) => String(id) === String(this.activeRoomId || ''))

      if (activeMatched) {
        this.fetchPushedMessageDetailAndInsert({chatId, messageId, room: matchedRoom})
        return
      }

      // 关键优化：如果该会话不在当前 room-list（分页未加载到），也要让 room-list 立刻可见。
      // 先尝试基于当前 rooms 更新；如果找不到则触发一次 rooms 刷新兜底；仍找不到则创建占位 room。
      if (matchedRoom) {
        this.fetchPushedMessageDetailAndUpdateRoom({chatId, messageId, room: matchedRoom})
        return
      }

      this.fetchPushedMessageDetailAndUpdateRoom({chatId, messageId, room: null, candidateChatIds})
    },

    ensureRoomForPushChatId({chatId, candidateChatIds}) {
      const cid = String(chatId || '').trim()
      if (!cid) return null

      const ids = Array.isArray(candidateChatIds) && candidateChatIds.length
          ? candidateChatIds
          : this.buildPushChatIdCandidates(cid)

      const existing = this.findRoomByAnyChatId(ids)
      if (existing) return existing

      const isGroup = cid.includes('@g.us') || ids.some((x) => String(x).includes('@g.us'))

      // 后端接口通常要求 chatId 为完整 jid（带 @lid/@c.us/@g.us）。
      // 优先选择带 @ 的候选值；否则按单聊规则补全。
      const pickPreferredChatId = () => {
        const withAt = ids.find((x) => String(x || '').includes('@'))
        if (withAt) return String(withAt)
        if (isGroup) {
          // group 没有 @ 时兜底拼接（极端情况）
          return cid.includes('@') ? cid : `${cid}@g.us`
        }
        try {
          return this.normalizeSingleChatId(cid)
        } catch (e) {
          return cid
        }
      }

      const roomId = pickPreferredChatId()

      const displayRoomName = String(roomId || '').replace(/@.*$/, '')

      // 创建最小可渲染 room，占位展示在 room-list；后续 loadRooms 会用真实数据覆盖。
      const now = Date.now()
      const room = {
        roomId,
        roomName: displayRoomName || roomId,
        avatar: '',
        unreadCount: 0,
        type: isGroup ? 'group' : 'single',
        isGroup,
        lastMessage: null,
        users: [
          {_id: this.currentUserId, username: '我'},
          {_id: roomId, username: displayRoomName || roomId}
        ],
        location: '',
        workingHours: '',
        isPinned: false,
        isSpecial: false,
        index: now,
        raw: null
      }

      this.rooms = [room, ...(this.rooms || [])]
      return room
    },

    buildPushChatIdCandidates(chatId) {
      const raw = String(chatId || '').trim()
      if (!raw) return []
      if (raw.includes('@g.us')) return [raw]

      const ids = []
      const push = (v) => {
        const s = String(v || '').trim()
        if (!s) return
        if (!ids.includes(s)) ids.push(s)
      }

      push(raw)

      const normalized = normalizeWaId(raw)
      if (normalized) {
        push(normalized)
        push(this.normalizeSingleChatId(normalized))
        push(`${normalized}@c.us`)
        push(`${normalized}@lid`)
      }

      // lid <-> pn mapping cache
      if (raw.endsWith('@lid')) {
        const pn = this.getPnByLidCached(raw)
        if (pn) push(pn)
      }
      if (raw.endsWith('@c.us')) {
        const lid = String(this.waJidMap?.pnToLid?.[raw] || '')
        if (lid) push(lid)
      }

      try {
        push(this.normalizeSingleChatId(raw))
      } catch (e) {
      }

      return ids
    },

    fetchPushedMessageDetailAndUpdateRoom({chatId, messageId, room, candidateChatIds}) {
      const cid = String(chatId || '')
      const mid = String(messageId || '')
      if (!cid || !mid) return Promise.resolve()

      const targetRoom = room || this.ensureRoomForPushChatId({chatId: cid, candidateChatIds}) || null
      if (!targetRoom) return Promise.resolve()

      // 同 ensureRoomForPushChatId：尽量保证使用完整 jid 作为 chatId。
      const ids = Array.isArray(candidateChatIds) && candidateChatIds.length
          ? candidateChatIds
          : this.buildPushChatIdCandidates(cid)

      // Backend APIs are generally more stable when using @lid for single chats.
      const preferredChatId = String(
        ids.find((x) => String(x || '').endsWith('@lid')) ||
        ids.find((x) => String(x || '').includes('@')) ||
        targetRoom?.roomId ||
        cid
      )

      const isActiveRoom = (() => {
        const active = String(this.activeRoomId || '')
        if (!active) return false
        if (String(targetRoom?.roomId || '') === active) return true
        return ids.some((x) => String(x || '') === active)
      })()

      const params = {
        chatId: preferredChatId,
        downloadMedia: true,
        limit: 0,
        merge: true,
        messageId: mid,
        offset: 0,
        ...(this.messagesPagination.filterAck ? {filterAck: this.messagesPagination.filterAck} : {}),
        ...(this.messagesPagination.filterFromMe === '' || this.messagesPagination.filterFromMe === null || typeof this.messagesPagination.filterFromMe === 'undefined'
            ? {}
            : {filterFromMe: this.messagesPagination.filterFromMe}),
        ...(this.messagesPagination.sortBy ? {sortBy: this.messagesPagination.sortBy} : {}),
        ...(this.messagesPagination.sortOrder ? {sortOrder: this.messagesPagination.sortOrder} : {})
      }

      if (process.env.NODE_ENV === 'development') {
        try {
          console.log('[WA-PUSH] fetch message detail', { chatId: params.chatId, messageId: mid, roomId: targetRoom?.roomId })
        } catch (e) {
        }
      }

      return getMessageByChatIdAndMessageId(params)
          .then((res) => {
            const list = this.normalizeGetMessageByChatIdPayload(res)

            const normalizeRawMessage = (it) => {
              if (!it) return null
              if (it?._data || typeof it?.fromMe === 'boolean' || it?.from || it?.body) return it
              return it?.message || it?.msg || it?.data || it?.result || null
            }

            const rawMessages = (list || []).map(normalizeRawMessage).filter(Boolean)
            const mapped = rawMessages
                .map((m) => this.mapApiMessageToUiMessage(m, targetRoom))
                .filter(Boolean)
                .filter((m) => m && m._id && (m.content || m.hasMedia || (m.files && m.files.length)))

            if (!mapped.length) return

            mapped.sort((a, b) => (a.timestamp || 0) - (b.timestamp || 0))
            const last = mapped[mapped.length - 1]

            targetRoom.lastMessage = {...last}
            targetRoom.lastMessageTimestamp = last.timestamp
            targetRoom.index = last.timestamp

            // 当前正在看的会话：不显示 badge counter
            if (isActiveRoom) {
              targetRoom.unreadCount = 0
            } else {
              targetRoom.unreadCount = Number(targetRoom.unreadCount || 0) + 1
            }
            this.rooms = [...(this.rooms || [])]
            this.emitUnreadTotal()
          })
          .catch((e) => {
            // 如果占位 room 仍未能取到消息详情，触发一次 rooms 刷新兜底，避免用户必须手动点刷新。
            try {
              if (!room) {
                this.loadRooms(false)
              }
            } catch (err) {
            }
            this.markApiFail(e, '服务暂不可用，请稍后重试')
          })
    },

    fetchPushedMessageDetailAndInsert({chatId, messageId, room}) {
      const targetRoom = room || this.findRoomByAnyChatId(this.buildPushChatIdCandidates(chatId)) || null
      const params = {
        chatId: String(targetRoom?.roomId || chatId),
        downloadMedia: true,
        limit: 0,
        merge: true,
        messageId,
        offset: 0,
        ...(this.messagesPagination.filterAck ? {filterAck: this.messagesPagination.filterAck} : {}),
        ...(this.messagesPagination.filterFromMe === '' || this.messagesPagination.filterFromMe === null || typeof this.messagesPagination.filterFromMe === 'undefined'
            ? {}
            : {filterFromMe: this.messagesPagination.filterFromMe}),
        ...(this.messagesPagination.sortBy ? {sortBy: this.messagesPagination.sortBy} : {}),
        ...(this.messagesPagination.sortOrder ? {sortOrder: this.messagesPagination.sortOrder} : {})
      }
      return getMessageByChatIdAndMessageId(params)
          .then((res) => {
            const candidateChatIds = this.buildPushChatIdCandidates(chatId)
            const activeMatched = candidateChatIds.some((id) => String(id) === String(this.activeRoomId || ''))
            if (!activeMatched) return

            const list = this.normalizeGetMessageByChatIdPayload(res)

            const normalizeRawMessage = (it) => {
              if (!it) return null
              if (it?._data || typeof it?.fromMe === 'boolean' || it?.from || it?.body) return it
              return it?.message || it?.msg || it?.data || it?.result || null
            }

            const rawMessages = (list || []).map(normalizeRawMessage).filter(Boolean)
            const filteredRawMessages = rawMessages
              .filter((raw) => {
                const data = raw?._data || raw || {}
                const fromMe = !!(raw?.fromMe ?? data?.id?.fromMe)
                return fromMe === false
              })

            const mapped = filteredRawMessages
                .map((m) => this.mapApiMessageToUiMessage(m, targetRoom))
                .filter(Boolean)
                .filter((m) => m && m._id && (m.content || m.hasMedia || (m.files && m.files.length)))

            if (!mapped.length) {
              this.$message?.warning?.('未获取到该 messageId 的消息详情，请确认 messageId 属于当前 chatId，且该消息确实为对方发送')
              return
            }

            mapped.sort((a, b) => (a.timestamp || 0) - (b.timestamp || 0))
            this.insertIncomingMessages(mapped, targetRoom)
          })
          .catch((e) => {
            this.$message?.error?.(e?.message || '获取消息详情失败')
          })
    },

    insertIncomingMessages(mapped = [], room) {
      const existing = Array.isArray(this.messages) ? this.messages : []
      const seen = new Set(existing.map((m) => m?._id).filter(Boolean).map((x) => String(x)))
      const toAdd = (mapped || []).filter((m) => m && m._id && !seen.has(String(m._id)))
      if (!toAdd.length) {
        this.$message?.info?.('该消息已存在于当前对话中')
        return
      }

      this.messages = [...existing, ...toAdd]

      try {
        toAdd.forEach((m) => {
          if (!m?._id) return
          this.messageIndex[String(m._id)] = m
        })
      } catch (e) {
      }

      const last = toAdd[toAdd.length - 1]
      if (room && last) {
        room.lastMessage = {...last}
        room.lastMessageTimestamp = last.timestamp
        room.index = last.timestamp
        room.unreadCount = 0
      }

      this.rooms = [...(this.rooms || [])]
    },

    buildSingleChatIdCandidates({lid, pn}) {
      const ids = []
      const push = (v) => {
        const s = String(v || '').trim()
        if (!s) return
        if (!ids.includes(s)) ids.push(s)
      }

      // normalizeSingleChatId will attach suffix if needed, but here lid/pn should already contain '@'
      // Prefer pn (@c.us) for matching existing rooms in the list; if not found, fall back to lid (@lid)
      push(pn)
      push(lid)

      // be defensive: if backend returns without suffix
      try {
        if (lid) push(this.normalizeSingleChatId(lid))
      } catch (e) {
      }
      try {
        if (pn) push(this.normalizeSingleChatId(pn))
      } catch (e) {
      }

      return ids
    },

    findRoomByAnyChatId(chatIds = []) {
      const list = Array.isArray(chatIds) ? chatIds : []
      if (!list.length) return null
      return (this.rooms || []).find((r) => r && list.some((id) => String(r.roomId) === String(id))) || null
    },

    async tryFindRoomByLoadingMore(chatIds = []) {
      const list = Array.isArray(chatIds) ? chatIds : []
      if (!list.length) return null

      let room = this.findRoomByAnyChatId(list)
      if (room) return room

      // 当 room-list 采用分页/无限滚动时，目标 room 可能不在第一页。
      // 这里在不依赖后端 filter 的情况下，主动加载更多页直到找到或到达上限。
      const maxPagesToLoad = 10
      let loaded = 0

      while (!room && this.roomsHasMore && !this.loadingMoreRooms && loaded < maxPagesToLoad) {
        await this.loadRooms(true)
        loaded += 1
        room = this.findRoomByAnyChatId(list)
      }

      return room
    },

    async tryResolveExistingRoomByRemote(chatIds = []) {
      const list = Array.isArray(chatIds) ? chatIds : []
      if (!list.length) return null

      // First: try local cache
      const cached = this.findRoomByAnyChatId(list)
      if (cached) return cached

      // Second: backend lookup (room might exist but not loaded due to pagination)
      for (const cid of list) {
        const chatId = String(cid || '').trim()
        if (!chatId) continue
        try {
          const params = {
            filter: {
              ids: [chatId]
            },
            pagination: {
              limit: 15,
              merge: true,
              offset: 1
            },
            from: this.normalizeFromUsId(this.currentUserId)
          }
          console.log(params,'params');
          
          const res = await getAllMessage(params)
          const remoteList = this.normalizeGetAllMessagePayload(res)
          const mapped = (Array.isArray(remoteList) ? remoteList : [])
            .map((it) => this.mapChatItemToRoom(it))
            .filter((r) => r && r.roomId)

          const room = mapped.find((r) => list.some((id) => String(r.roomId) === String(id))) || null
          if (room) {
            const existingIds = new Set((this.rooms || []).map((r) => String(r?.roomId || '')))
            const toAdd = mapped.filter((r) => r?.roomId && !existingIds.has(String(r.roomId)))
            if (toAdd.length) {
              this.applyPinnedFromLocalCache(toAdd)
              this.rooms = [...toAdd, ...(this.rooms || [])]
            }
            return this.findRoomByAnyChatId(list) || room
          }
        } catch (e) {
        }
      }

      return null
    },

    async openOrCreateSingleChatByLidPn({ input, lid, pn, contactInfo }) {
      const phone = String(input || '').trim()
      if (!phone) return

      const chatIds = this.buildSingleChatIdCandidates({ lid, pn })
      const existRoom = await this.tryResolveExistingRoomByRemote(chatIds)
      if (existRoom) {
        try {
          const displayName = String(contactInfo?.name || '')
          const displayAvatar = String(contactInfo?.avatar || '')
          if (displayName) {
            existRoom.roomName = displayName
            try {
              if (Array.isArray(existRoom.users)) {
                const peer = existRoom.users.find((u) => u && String(u._id || '') === String(existRoom.roomId || ''))
                if (peer) {
                  peer.username = displayName
                }
              }
            } catch (e) {
            }
          }
          if (displayAvatar) {
            existRoom.avatar = displayAvatar
          }
          // trigger re-render if needed
          this.rooms = [...(this.rooms || [])]
        } catch (e) {
        }
        this.tempRoom = null
        this.activeRoomId = existRoom.roomId
        this.fetchMessages({ room: existRoom, options: { reset: true } })
        return
      }

      const chatId = String(lid || pn || (chatIds[0] || '')).trim() || this.normalizeSingleChatId(lid)
      const tempId = `temp_${Date.now()}`
      const displayName = String(contactInfo?.name || phone)
      const displayAvatar = String(contactInfo?.avatar || '')
      const tempRoom = {
        roomId: tempId,
        roomName: displayName,
        avatar: displayAvatar,
        unreadCount: 0,
        type: 'single',
        lastMessage: null,
        users: [
          { _id: this.currentUserId, username: '我' },
          { _id: chatId, username: displayName },
        ],
        location: '',
        workingHours: '',
        isPinned: false,
        isSpecial: false,
        index: Date.now(),
        isTemp: true,
        targetChatId: chatId,
        targetChatIds: chatIds
      }

      this.tempRoom = tempRoom
      this.activeRoomId = ''
      this.messages = []
      this.messagesLoaded = true

      this.$nextTick(() => {
        try {
          this.$refs?.chatComponent?.fetchRoom?.({ room: tempRoom })
        } catch (e) {
        }
      })
    },

    async resolveTempRoomAfterFirstSend({preferredChatIds = [], token} = {}) {
      const currentToken = token || ++this._tempRoomResolveToken
      const ids = Array.isArray(preferredChatIds) ? preferredChatIds : []

      this._tempRoomLastKnownChatId = ids[0] ? String(ids[0]) : ''

      try {
        await this.loadRooms(false)
      } catch (e) {
        // ignore, selection fallback below
      }

      // stale request guard
      if (currentToken !== this._tempRoomResolveToken) return

      // 1) prefer exact match by lid/pn
      const realRoom = this.findRoomByAnyChatId(ids)
      if (realRoom) {
        this.tempRoom = null
        this.activeRoomId = realRoom.roomId
        this.fetchMessages({room: realRoom, options: {reset: true}})
        return
      }

      // 2) fallback to newest room (first one, since room list is time desc in UI)
      const first = (this.rooms || [])[0] || null
      if (first && first.roomId) {
        this.tempRoom = null
        this.activeRoomId = first.roomId
        this.fetchMessages({room: first, options: {reset: true}})
        return
      }

      // 3) last resort: keep empty selection (avoid selecting a non-existing roomId)
      this.tempRoom = null
      this.activeRoomId = ''
      this.messages = []
      this.messagesLoaded = true
    },
    normalizeSingleChatId(value) {
      const raw = String(value || '').trim()
      if (!raw) return ''
      if (raw.includes('@')) return raw
      // 单聊目前优先使用 lid（形如 12345@lid）。
      // 为兼容旧逻辑：如果传入的是纯数字/手机号样式，则默认拼接 @lid。
      // 如果未来仍需要 pn（@c.us），应直接传入带 @ 的完整 jid。
      if (/^\d+$/.test(raw)) return `${raw}@lid`
      return `${raw}@c.us`
    },
    isGroupRoom(room) {
      if (!room) return false
      if (room?.isGroup === true) return true
      if (room?.type === 'group') return true
      const rid = room?.roomId
      return typeof rid === 'string' ? rid.includes('@g.us') : false
    },
    buildForwardedUiMessage(originalMessage, roomId) {
      const ts = Date.now()
      const base = originalMessage && typeof originalMessage === 'object' ? originalMessage : {}

      // 转发消息本质上是“我”在目标会话中发送了一条内容相同的新消息
      // 这里用乐观消息保证 room-list 与对话框立即更新。
      const msg = {
        ...base,
        _id: `fwd_${roomId || 'unknown'}_${ts}`,
        senderId: this.currentUserId,
        username: '我',
        timestamp: ts,
        ...formatChatTime(ts),
        saved: true,
        distributed: false,
        seen: false,
        deleted: false,
      }

      // 转发不继承 reply 引用（避免引用到原会话的 messageId）
      try {
        delete msg.replyMessage
        delete msg.replyTo
      } catch (e) {
      }

      return msg
    },

    applyForwardSyncUpdate({chatId, forwardedUiMessage}) {
      if (!chatId || !forwardedUiMessage) return

      // 1) room-list：更新 lastMessage + 排序字段
      const room = (this.rooms || []).find((r) => r && r.roomId === chatId)
      if (room) {
        room.lastMessage = {...forwardedUiMessage}
        room.lastMessageTimestamp = forwardedUiMessage.timestamp
        room.index = forwardedUiMessage.timestamp
        room.unreadCount = 0
      }

      // 2) 当前对话框：如果目标就是当前激活会话，追加到 messages
      if (String(this.activeRoomId || '') === String(chatId)) {
        const exists = (this.messages || []).some((m) => String(m?._id) === String(forwardedUiMessage?._id))
        if (!exists) {
          this.messages.push(forwardedUiMessage)
        }
      }

      // 3) 写入缓存（用于 replyTo 还原等场景）
      try {
        if (forwardedUiMessage?._id) {
          this.messageIndex[String(forwardedUiMessage._id)] = forwardedUiMessage
        }
      } catch (e) {
      }
    },

    async handleForwardMessage(payload) {
      if (!payload || payload.canceled) return

      const message = payload?.message
      const selectedMessages = Array.isArray(payload?.messages) ? payload.messages : null
      const contacts = Array.isArray(payload?.contacts) ? payload.contacts : []
      const done = typeof payload?.done === 'function' ? payload.done : null

      const messageIdList = (selectedMessages && selectedMessages.length
        ? selectedMessages
        : (message ? [message] : [])
      )
        .map((m) => m?._id || m?.id)
        .filter((id) => id)

      const uniqMessageIdList = Array.from(new Set(messageIdList.map((x) => String(x))))
      if (!uniqMessageIdList.length) {
        this.$message?.warning?.('缺少 messageId，无法转发')
        done?.(false)
        return
      }
      if (!contacts.length) {
        this.$message?.warning?.('请选择联系人')
        done?.(false)
        return
      }

      const session = 'default'

      const chatIdListRaw = contacts
        .map((c) => c?.id || c?.chatId)
        .filter((id) => id)
        .map((id) => String(id))
      const chatIdList = Array.from(new Set(chatIdListRaw))
      if (!chatIdList.length) {
        this.$message?.warning?.('联系人缺少 chatId，无法转发')
        done?.(false)
        return
      }

      try {
        await forwardMessage({
          chatIdList,
          messageIdList: uniqMessageIdList,
          session
        })

        // UI 侧：对每个目标会话做一次乐观同步更新。
        // 多条消息转发时，只用最新一条来更新 room-list 的 lastMessage（避免大量插入导致 UI 卡顿）。
        const lastMsg = (selectedMessages && selectedMessages.length)
          ? selectedMessages[selectedMessages.length - 1]
          : message

        // 同步更新 room-list + 对话框
        const missingRoomIds = new Set()
        ;(chatIdList || []).forEach((chatId) => {
          if (!chatId) return

          const room = (this.rooms || []).find((r) => r && r.roomId === chatId) || null
          const forwardedUiMessage = this.buildForwardedUiMessage(lastMsg || {}, chatId)
          this.applyForwardSyncUpdate({ chatId, forwardedUiMessage })
          if (!room) missingRoomIds.add(String(chatId))
        })

        // 如果目标会话不在当前 room-list（可能分页未加载到），只刷新一次 rooms 兜底
        if (missingRoomIds.size > 0) {
          this.loadRooms(false)
        }

        this.$message?.success?.('转发成功')
        done?.(true)
      } catch (e) {
        this.$message?.error?.(e?.message || '转发失败')
        done?.(false)
      }
    },

    handleClearChat(roomId) {
      const chatId = String(roomId || '')
      if (!chatId) return
      if (this.clearingChat) return
      this.clearingChat = true

      return deleteAllMessageByChatId({chatId})
          .then(() => {
            const room = (this.rooms || []).find((r) => String(r.roomId) === chatId)
            if (room) {
              room.lastMessage = null
              room.lastMessageTimestamp = 0
              room.index = room.index || 0
            }

            if (String(this.activeRoomId || '') === chatId) {
              this.messages = []
              this.messagesLoaded = true
              this.messagesPagination = {
                ...this.messagesPagination,
                chatId,
                offset: 1,
                messageId: ''
              }
            }

            this.$message?.success?.('已清空聊天记录')
          })
          .catch((e) => {
            this.$message?.error?.(e?.message || '清空聊天失败')
            throw e
          })
          .finally(() => {
            this.clearingChat = false
          })
    },

    handleLeaveGroup(roomId) {
      const groupId = String(roomId || '')
      if (!groupId) return
      if (this.leavingGroup) return
      this.leavingGroup = true

      return leaveGroup({groupId})
          .then(() => {
            const isActive = String(this.activeRoomId || '') === groupId
            this.rooms = (this.rooms || []).filter((r) => r && String(r.roomId) !== groupId)
            if (isActive) {
              this.activeRoomId = ''
              this.messages = []
              this.messagesLoaded = true
            }
            this.$message?.success?.('已退出群组')
          })
          .catch((e) => {
            this.$message?.error?.(e?.message || '退出群组失败')
            throw e
          })
          .finally(() => {
            this.leavingGroup = false
          })
    },
    ensureFileWithName(raw, fallbackName = 'file') {
      if (!raw) return null
      try {
        if (raw instanceof File) return raw
      } catch (e) {
      }

      // Blob 没有 name，后端可能会基于 originalFilename 解析后缀，缺失会导致 String index out of range
      const blob = raw instanceof Blob ? raw : null
      if (!blob) return raw

      const type = blob.type || ''
      const mimeToExt = {
        'image/png': 'png',
        'image/jpeg': 'jpg',
        'image/jpg': 'jpg',
        'image/gif': 'gif',
        'image/webp': 'webp',
        'application/pdf': 'pdf',
        'text/plain': 'txt',
        'audio/mpeg': 'mp3',
        'audio/mp3': 'mp3',
        'audio/wav': 'wav',
        'audio/ogg': 'ogg',
        'audio/webm': 'webm',
        'video/mp4': 'mp4',
        'video/webm': 'webm'
      }

      let name = fallbackName || 'file'
      const hasExt = /\.[A-Za-z0-9]+$/.test(name)
      if (!hasExt) {
        const ext = mimeToExt[type] || 'bin'
        name = `${name}.${ext}`
      }

      try {
        return new File([blob], name, {type: blob.type || 'application/octet-stream'})
      } catch (e) {
        // 兜底：返回原 blob（极少数环境不支持 File 构造）
        return blob
      }
    },
    handleRefresh() {
      const currentRoomId = this.activeRoomId
      const currentRoom = currentRoomId
          ? (this.rooms || []).find(r => r && r.roomId === currentRoomId)
          : null

      return Promise.resolve()
          .then(() => this.loadRooms(false))
          .then(() => {
            const nextRoom = currentRoomId
                ? (this.rooms || []).find(r => r && r.roomId === currentRoomId)
                : null
            const roomToFetch = nextRoom || currentRoom
            if (roomToFetch) {
              return this.fetchMessages({room: roomToFetch, options: {reset: true}})
            }
          })
    },
    normalizeOssUploadUrl(res) {
      const result = res?.result || res?.data?.result
      if (result?.url && typeof result.url === 'string') return result.url

      const payload = res?.data || res
      const url = payload?.url || payload?.link || payload?.fileUrl || ''
      return typeof url === 'string' ? url : ''
    },
    clearAllTypingTimers() {
      try {
        Object.keys(this.typingTimers || {}).forEach((roomId) => {
          if (this.typingTimers[roomId]) {
            clearTimeout(this.typingTimers[roomId])
          }
        })
      } catch (e) {
      }
      this.typingTimers = {}
      this.typingStates = {}
      this.typingLastStartAt = {}
    },
    getPinnedChatIdSet() {
      try {
        const list = Storage.get('wa_pinned_chat_ids')
        const arr = Array.isArray(list) ? list : []
        return new Set(arr.map((x) => String(x)))
      } catch (e) {
        return new Set()
      }
    },
    setPinnedChatIdSet(set) {
      try {
        Storage.set('wa_pinned_chat_ids', Array.from(set))
      } catch (e) {
      }
    },
    applyPinnedFromLocalCache(rooms = []) {
      const pinned = this.getPinnedChatIdSet()
      rooms.forEach((r) => {
        if (!r || !r.roomId) return
        const rid = String(r.roomId)
        if (pinned.has(rid)) r.isPinned = true
      })
      return rooms
    },
    toggleRoomPin(room) {
      if (!room || !room.roomId) return Promise.resolve()
      const chatId = String(room.roomId)

      const messageId =
          room?.raw?.lastMessage?.data?.id?._serialized ||
          room?.raw?.lastMessage?.data?.id?.id ||
          room?.lastMessage?._id
      if (!messageId) {
        return Promise.reject(new Error('Missing message id (room.raw.lastMessage.data.id.id)'))
      }

      const prev = !!room.isPinned
      const next = !prev

      // optimistic update
      room.isPinned = next
      const pinnedSet = this.getPinnedChatIdSet()
      if (next) pinnedSet.add(chatId)
      else pinnedSet.delete(chatId)
      this.setPinnedChatIdSet(pinnedSet)

      // 根据当前状态调用不同接口：未置顶则置顶，已置顶则取消置顶
      const apiCall = prev ? unTopMessageByMessageId : topMessageByMessageId

      return apiCall({chatId, messageId, duration: 604800})
          .catch((e) => {
            // rollback
            room.isPinned = prev
            const rollbackSet = this.getPinnedChatIdSet()
            if (prev) rollbackSet.add(chatId)
            else rollbackSet.delete(chatId)
            this.setPinnedChatIdSet(rollbackSet)
            throw e
          })
    },
    initPage() {
      return Promise.resolve()
          .then(() => this.getUserInfo())
          .then(() => this.loadRooms())
          .then(() => {
            this.resetServiceUnavailable()
            const whatsappId = this?.$route?.query?.whatsappId;
            if (whatsappId) {
              const raw = String(whatsappId)
              const normalized = normalizeWaId(raw) || raw

              // 使用 openChatByChatId 统一处理：
              // - room 在后续分页时会自动 load more
              // - 如后端支持 ids filter，会尝试远程精确查询
              // - 最后兜底创建占位 room
              this.openChatByChatIdWithLoading(normalized)
              return
            }

            this.tempRoom = null
            this.activeRoomId = ''
            this.messages = []
            this.messagesLoaded = true
          })
    },

    normalizeGetAllMessagePayload(res) {
      const payload = res?.result || res?.data?.result || res?.data || res
      if (Array.isArray(payload)) return payload
      if (Array.isArray(payload?.allMessageList)) return payload.allMessageList
      if (Array.isArray(payload?.list)) return payload.list
      if (Array.isArray(payload?.records)) return payload.records
      return []
    },

    normalizeGetMessageByChatIdPayload(res) {
      const payload = res?.result || res?.data?.result || res?.data || res
      if (Array.isArray(payload)) return payload
      if (Array.isArray(payload?.messages)) return payload.messages
      if (Array.isArray(payload?.list)) return payload.list
      if (Array.isArray(payload?.records)) return payload.records
      if (payload && typeof payload === 'object') return [payload]
      return []
    },

    normalizeChatItemGroupFields(item) {
      const rawType = item?.type
      const rawIsGroup = item?.isGroup

      let type = rawType
      if (type !== 'group' && type !== 'single') {
        type = undefined
      }

      let isGroup
      if (typeof rawIsGroup === 'boolean') {
        isGroup = rawIsGroup
      }

      // isGroup 为权威字段：只要明确给出 isGroup，则强制将 type 与之保持一致
      if (typeof isGroup === 'boolean') {
        return {
          isGroup,
          type: isGroup ? 'group' : 'single'
        }
      }

      if (typeof isGroup !== 'boolean') {
        if (type === 'group') isGroup = true
        if (type === 'single') isGroup = false
      }

      if (type !== 'group' && type !== 'single') {
        if (isGroup === true) type = 'group'
        if (isGroup === false) type = 'single'
      }

      return {
        isGroup: typeof isGroup === 'boolean' ? isGroup : false,
        type: type || 'single'
      }
    },

    resolveWahaAckValue(rawMessage) {
      const msg = rawMessage && typeof rawMessage === 'object' ? rawMessage : {}
      const data = msg?.data && typeof msg.data === 'object'
        ? msg.data
        : (msg?._data && typeof msg._data === 'object' ? msg._data : {})

      const candidates = [
        msg?.ack,
        data?.ack,
        data?.status,
        data?.info?.status,
        msg?.status
      ]
        .map((v) => (typeof v === 'string' && v.trim() !== '' ? Number(v) : v))
        .filter((v) => typeof v === 'number' && Number.isFinite(v))

      if (!candidates.length) return null
      return Math.max(...candidates)
    },

    mapApiMessageToUiMessage(msg, room) {
      const data = msg?._data || {}
      const tsSeconds = msg?.timestamp ?? data?.t
      const tsMs = typeof tsSeconds === 'number'
          ? (tsSeconds > 1e12 ? tsSeconds : tsSeconds * 1000)
          : Date.now()

      const normalizeSenderJid = (jid) => {
        const s = String(jid || '').trim()
        if (!s) return ''
        const m = s.match(/^([^@]+)@(.+)$/)
        if (!m) return s
        const local = String(m[1] || '')
        const domain = String(m[2] || '')
        const localNormalized = local.replace(/:\d+$/, '')
        return `${localNormalized}@${domain}`
      }

      const ack = this.resolveWahaAckValue(msg)
      const distributed = typeof ack === 'number' ? ack >= 2 : false
      const seen = typeof ack === 'number' ? ack >= 3 : false

      const id =
          msg?.id ||
          data?.id?._serialized ||
          data?.id?.id ||
          `msg_${room?.roomId || 'unknown'}_${tsMs}`

      const isGroupRoom = (() => {
        if (room?.isGroup === true) return true
        if (room?.type === 'group') return true
        if (data?.info?.isGroup === true) return true
        const rawFrom = String(msg?.from || data?.from?._serialized || '')
        if (rawFrom.includes('@g.us')) return true
        const rid = room?.roomId
        return typeof rid === 'string' ? rid.includes('@g.us') : false
      })()

      const fromMe = !!(msg?.fromMe ?? data?.id?.fromMe)
      const groupParticipant = (
        data?.info?.sender ||
        msg?._data?.info?.sender ||
        data?.author ||
        data?.participant ||
        data?.sender ||
        ''
      )
      const rawSenderId = normalizeSenderJid(
        (isGroupRoom && !fromMe)
          ? groupParticipant
          : (msg?.from || data?.from?._serialized || data?.from?.user || '')
      )
      const senderId = (() => {
        if (fromMe) return this.currentUserId
        // 兜底：若 currentUserId 被错误设置为对方 jid，会导致对方消息被当成“我发的”。
        // 这里在 fromMe=false 时强制避免 senderId 与 currentUserId 相等。
        if (String(rawSenderId || '') && String(rawSenderId) === String(this.currentUserId || '')) {
          return `peer_${rawSenderId}`
        }
        return rawSenderId
      })()

      // 提取内容：优先 body，其次处理媒体描述
      let content = msg?.body ?? data?.body ?? ''
      const hasMedia = !!(msg?.hasMedia ?? data?.hasMedia)
      const type = data?.type || 'chat'

      // 后端有些场景会把媒体信息放在 msg.media / data.media 中
      const media = msg?.media || data?.media
      let mediaUrl = media?.url || ''
      const mediaMimetype = media?.mimetype || ''
      const mediaFilename = media?.filename || ''
      const files = []
      if (hasMedia && mediaUrl) {
        // MessageFiles / media-file utils 依赖 file.type 来判断是否图片/视频/音频
        const extFromMime = (m) => {
          if (!m || typeof m !== 'string') return ''
          const mm = m.toLowerCase()
          if (mm.includes('png')) return 'png'
          if (mm.includes('jpeg')) return 'jpg'
          if (mm.includes('jpg')) return 'jpg'
          if (mm.includes('gif')) return 'gif'
          if (mm.includes('webp')) return 'webp'
          if (mm.includes('svg')) return 'svg'
          if (mm.includes('mp4')) return 'mp4'
          if (mm.includes('webm')) return 'webm'
          if (mm.includes('quicktime')) return 'mov'
          if (mm.includes('pdf')) return 'pdf'
          if (mm.includes('mpeg') || mm.includes('mp3')) return 'mp3'
          if (mm.includes('wav')) return 'wav'
          if (mm.includes('ogg')) return 'ogg'
          return ''
        }

        const extFromUrl = (u) => {
          const s = String(u || '').split('?')[0].split('#')[0].toLowerCase()
          const idx = s.lastIndexOf('.')
          if (idx === -1) return ''
          const ext = s.slice(idx + 1)
          if (!ext) return ''
          if (ext.includes('/')) return ''
          return ext
        }

        const extension = extFromMime(mediaMimetype) || extFromUrl(mediaUrl)
        const displayName = mediaFilename || (extension ? `file.${extension}` : 'file')
        const nameNoExt = displayName.includes('.') ? displayName.slice(0, displayName.lastIndexOf('.')) : displayName
        files.push({
          url: mediaUrl,
          type: mediaMimetype || (extension ? extension : undefined),
          name: nameNoExt,
          extension
        })
      }

      // 如果是媒体/特殊消息但没有文字内容，根据类型生成占位描述，避免空白气泡
      if (!content && hasMedia && (!files || files.length === 0)) {
        switch (type) {
          case 'image':
            content = '[图片]'
            break
          case 'video':
            content = '[视频]'
            break
          case 'audio':
          case 'ptt':
            content = '[语音]'
            break
          case 'document':
            content = '[文件]'
            break
          case 'sticker':
            content = '[表情]'
            break
          case 'location':
            content = '[位置]'
            break
          case 'vcard':
          case 'multi_vcard':
            content = '[名片]'
            break
          case 'poll':
            content = '[投票]'
            break
          case 'gif':
            content = '[GIF]'
            break
          case 'order':
            content = '[订单]'
            break
          case 'product':
            content = '[商品]'
            break
          case 'template_button_reply':
            content = '[按钮回复]'
            break
          default:
            content = '[媒体]'
        }
      }

      // 回复消息：将后端的 reply/quoted 信息映射为 UI 所需的 replyMessage
      // UI 渲染只认 message.replyMessage（MessageReply.vue）
      const replyToId =
          data?.replyTo ||
          data?.quotedStanzaID ||
          data?.quotedMsgId ||
          data?.contextInfo?.stanzaId ||
          data?.contextInfo?.quotedMessageId ||
          data?.contextInfo?.quotedStanzaID ||
          data?.context?.stanzaId ||
          data?.context?.quotedStanzaID ||
          ''

      const quoted =
          msg?.quotedMsg ||
          data?.quotedMsg ||
          data?.contextInfo?.quotedMessage ||
          data?.contextInfo?.quotedMsg ||
          data?.context?.quotedMessage ||
          data?.context?.quotedMsg ||
          null

      const replyToObj = (() => {
        const r = msg?.replyTo ?? data?.replyTo
        if (!r) return null
        if (typeof r === 'string' || typeof r === 'number') return null
        return r
      })()

      const buildReplyMessage = () => {
        // 1) 兼容：后端把被回复的消息对象直接放在 msg.replyTo / data.replyTo
        if (replyToObj) {
          const rData = replyToObj?._data || replyToObj
          const rId =
              replyToObj?.id ||
              rData?.id?._serialized ||
              rData?.id?.id ||
              ''
          const rFromMe = !!(replyToObj?.fromMe ?? rData?.id?.fromMe)
          const rSenderId = rFromMe
              ? this.currentUserId
              : normalizeSenderJid(replyToObj?.from || rData?.from?._serialized || rData?.from?.user || '')
          const rBody = replyToObj?.body ?? rData?.body ?? ''
          const rHasMedia = !!(replyToObj?.hasMedia ?? rData?.hasMedia)
          const rMedia = replyToObj?.media || rData?.media
          let rMediaUrl = rMedia?.url || ''

          const rFiles = []
          if (rHasMedia && rMediaUrl) {
            const rMimetype = rMedia?.mimetype || ''
            const rFilename = rMedia?.filename || ''

            const extFromMime = (m) => {
              if (!m || typeof m !== 'string') return ''
              const mm = m.toLowerCase()
              if (mm.includes('png')) return 'png'
              if (mm.includes('jpeg')) return 'jpg'
              if (mm.includes('jpg')) return 'jpg'
              if (mm.includes('gif')) return 'gif'
              if (mm.includes('webp')) return 'webp'
              if (mm.includes('svg')) return 'svg'
              if (mm.includes('mp4')) return 'mp4'
              if (mm.includes('webm')) return 'webm'
              if (mm.includes('quicktime')) return 'mov'
              if (mm.includes('pdf')) return 'pdf'
              if (mm.includes('mpeg') || mm.includes('mp3')) return 'mp3'
              if (mm.includes('wav')) return 'wav'
              if (mm.includes('ogg')) return 'ogg'
              return ''
            }

            const extension = extFromMime(rMimetype)
            const displayName = rFilename || (extension ? `file.${extension}` : 'file')
            const nameNoExt = displayName.includes('.') ? displayName.slice(0, displayName.lastIndexOf('.')) : displayName

            const extra = {
              ...(rMedia?.size != null ? {size: rMedia.size} : {}),
              ...(rMedia?.duration != null ? {duration: rMedia.duration} : {}),
              ...(rMedia?.preview ? {preview: rMedia.preview} : {})
            }

            rFiles.push({
              url: rMediaUrl,
              type: rMimetype || (extension ? extension : undefined),
              name: nameNoExt,
              extension,
              ...extra
            })
          }

          return {
            _id: rId,
            content: rBody || '',
            senderId: rSenderId,
            ...(rFiles.length ? {files: rFiles} : {})
          }
        }

        // 2) 如果后端直接带了 quoted message 内容
        if (quoted) {
          const qData = quoted?._data || quoted
          const qId =
              quoted?.id ||
              qData?.id?._serialized ||
              qData?.id?.id ||
              replyToId ||
              ''
          const qFromMe = !!(quoted?.fromMe ?? qData?.id?.fromMe)
          const qSenderId = qFromMe
              ? this.currentUserId
              : normalizeSenderJid(quoted?.from || qData?.from?._serialized || qData?.from?.user || '')
          const qBody = quoted?.body ?? qData?.body ?? ''
          const qType = qData?.type || 'chat'
          return {
            _id: qId,
            content: qBody || (qType ? `[${qType}]` : ''),
            senderId: qSenderId,
            username: qFromMe ? '我' : (room?.roomName || '')
          }
        }

        // 3) 如果只有 replyToId：尝试用当前已加载的 messages 找到被引用的消息
        if (replyToId) {
          const exist =
              this.messageIndex?.[String(replyToId)] ||
              (this.messages || []).find((m) => m && String(m._id) === String(replyToId))
          if (exist) {
            return {
              _id: exist._id,
              content: exist.content || '',
              senderId: exist.senderId,
              username: exist.username || '',
              ...(exist.files?.length ? {files: exist.files} : {})
            }
          }
        }

        return null
      }

      const replyMessage = buildReplyMessage()

      return {
        _id: id,
        content,
        senderId,
        userName: typeof msg?.userName === 'string' ? msg.userName : '',
        picture: typeof msg?.picture === 'string' ? msg.picture : '',
        username: (() => {
          if (isGroupRoom) {
            return (
              msg?.username ||
              msg?.userName ||
              data?.info?.pushName ||
              msg?._data?.info?.pushName ||
              ''
            )
          }
          return fromMe ? '我' : (room?.roomName || '')
        })(),
        avatar: (() => {
          if (isGroupRoom) {
            return (
              msg?.avatar ||
              msg?.picture ||
              ''
            )
          }
          return fromMe ? '' : (room?.avatar || '')
        })(),
        timestamp: tsMs,
        ...formatChatTime(tsMs),
        system: false,
        saved: typeof ack === 'number' ? ack >= 1 : true,
        distributed,
        seen,
        deleted: false,
        reactions: {},
        hasMedia,
        type,
        ...(replyToId ? {replyTo: String(replyToId)} : {}),
        ...(replyMessage ? {replyMessage} : {}),
        ...(files.length ? {files} : {}),
        raw: msg
      }
    },

    mergeMessagesPrepend(existing = [], olderBatch = []) {
      if (!olderBatch?.length) return existing
      const seen = new Set(existing.map((m) => m?._id).filter(Boolean))
      const result = []

      olderBatch.forEach((m) => {
        if (!m?._id) return
        if (seen.has(m._id)) return
        seen.add(m._id)
        result.push(m)
      })

      return [...result, ...existing]
    },

    mapChatItemToRoom(item) {
      const isMessageOverviewShape = !!(
        item &&
        String(item?.id || '').trim() &&
        Object.prototype.hasOwnProperty.call(item, 'lastMessage')
      )

      const normalizeAvatarUrl = (url) => {
        const s = String(url || '').trim()
        if (!s) return ''
        return s
      }

      if (isMessageOverviewShape) {
        const roomId = String(item?.id || '').trim()
        const isGroup = roomId.includes('@g.us')
        const roomName = (() => {
          const n = String(item?.name || '').trim()
          if (n) return n
          const normalized = normalizeWaId(roomId)
          return normalized || roomId
        })()

        const last = item?.lastMessage || null
        const tsSeconds = last?.timestamp
        const tsMs = typeof tsSeconds === 'number'
          ? (tsSeconds > 1e12 ? tsSeconds : tsSeconds * 1000)
          : Date.now()

        const ack = this.resolveWahaAckValue(last)
        const distributed = typeof ack === 'number' ? ack >= 2 : false
        const seen = typeof ack === 'number' ? ack >= 3 : false

        const hasLastBody = last?.body !== null && last?.body !== undefined && String(last?.body || '').trim() !== ''
        const lastMessage = hasLastBody
          ? {
            _id: String(last?.id || `msg_${roomId}_${tsMs}`),
            content: String(last?.body || ''),
            senderId: last?.fromMe ? this.currentUserId : (String(last?.from || roomId)),
            timestamp: tsMs,
            ...formatChatTime(tsMs),
            saved: typeof ack === 'number' ? ack >= 1 : true,
            distributed,
            seen,
            deleted: false,
          }
          : null

        return {
          roomId,
          roomName,
          avatar: normalizeAvatarUrl(item?.picture),
          unreadCount: 0,
          type: isGroup ? 'group' : 'single',
          isGroup,
          lastMessage,
          users: [
            { _id: this.currentUserId, username: '我' },
            { _id: roomId, username: roomName || roomId },
          ],
          location: '',
          workingHours: '',
          isPinned: false,
          isSpecial: false,
          index: tsMs,
          raw: item,
        }
      }

      const isNewShape = !!(item && (item.conversationTimestamp != null || item.picture != null || Object.prototype.hasOwnProperty.call(item, 'abo')) && !item.lastMessage)


      if (isNewShape) {
        const rawId = String(item?.id || '').trim()
        const isGroup = rawId.includes('@g.us') || item?.isGroup === true || item?.type === 'group'
        const roomId = rawId
        const roomName = (() => {
          const n = String(item?.name || '').trim()
          if (n) return n
          const normalized = normalizeWaId(roomId)
          return normalized || roomId
        })()

        const tsSeconds = item?.conversationTimestamp
        const tsMs = typeof tsSeconds === 'number'
            ? (tsSeconds > 1e12 ? tsSeconds : tsSeconds * 1000)
            : Date.now()

        const lastMessageId = `msg_${roomId}_${tsMs}`
        const senderId = roomId

        return {
          roomId,
          roomName,
          avatar: normalizeAvatarUrl(item?.picture),
          unreadCount: 0,
          type: isGroup ? 'group' : 'single',
          isGroup,
          lastMessage: item?.body
              ? {
                _id: lastMessageId,
                content: item?.body,
                senderId,
                timestamp: tsMs,
                ...formatChatTime(tsMs),
                saved: true,
                distributed: false,
                seen: false,
                deleted: false,
              }
              : null,
          users: [
            {_id: this.currentUserId, username: '我'},
            {_id: roomId, username: roomName || roomId},
          ],
          location: '',
          workingHours: '',
          isPinned: false,
          isSpecial: false,
          index: tsMs,
          raw: item,
        }
      }

      const last = item?.lastMessage || {}
      const data = last?.data || {}

      const groupFields = this.normalizeChatItemGroupFields(item)

      const resolveSingleAvatar = (it) => {
        const pic = it?.picture
        if (typeof pic === 'string' && pic.trim()) return normalizeAvatarUrl(pic)
        const a1 = it?.avatar
        if (typeof a1 === 'string' && a1.trim()) return normalizeAvatarUrl(a1)
        const a2 = it?.profilePicUrl
        if (typeof a2 === 'string' && a2.trim()) return normalizeAvatarUrl(a2)
        const a3 = it?.photo
        if (typeof a3 === 'string' && a3.trim()) return normalizeAvatarUrl(a3)
        return ''
      }

      const normalizeGroupId = (val) => {
        const s = String(val || '').trim()
        if (!s) return ''
        if (s.includes('@g.us')) return s
        if (s.includes('@')) return s
        if (/^\d+$/.test(s)) return `${s}@g.us`
        return s
      }

      const peerFrom = item?.from || last?.from || data?.from?._serialized || data?.from?.user
      const peerTo = item?.to || last?.to || data?.to?._serialized || data?.to?.user

      // 群聊：必须使用群 remoteJid（xxx@g.us）。
      // 注意某些历史同步消息（isMdHistoryMsg）里，lastMessage.to 可能是我自己的 c.us/lid，
      // 如果用它当 roomId，会导致后续按 chatId 拉取消息失败。
      const rawGroupId =
          item?.id?._serialized ||
          item?.id?.remote ||
          item?.id ||
          data?.id?.remote ||
          data?.quotedRemoteJid?._serialized ||
          data?.from?._serialized ||
          ''

      const roomId = groupFields?.isGroup
          ? normalizeGroupId(rawGroupId)
          : (last?.fromMe ? (peerTo || '') : (peerFrom || ''))

      const roomName = (() => {
        const n = String(item?.name || '').trim()
        if (n) return n
        const subject = String(item?.groupMetadata?.subject || '').trim()
        if (subject) return subject
        const notify = String(data?.notifyName || '').trim()
        if (notify) return notify
        const normalized = normalizeWaId(roomId)
        return normalized || roomId
      })()

      const tsSeconds = last?.timestamp || data?.t
      const tsMs = typeof tsSeconds === 'number' ? tsSeconds * 1000 : Date.now()

      const ack = this.resolveWahaAckValue(last)
      const distributed = typeof ack === 'number' ? ack >= 2 : false
      const seen = typeof ack === 'number' ? ack >= 3 : false

      const lastMessageId =
          data?.id?._serialized ||
          data?.id?.id ||
          last?._id ||
          `msg_${roomId}_${tsMs}`

      const senderId = last?.fromMe ? this.currentUserId : roomId

      return {
        roomId,
        roomName,
        avatar: resolveSingleAvatar(item),
        unreadCount: item?.unreadCount || 0,
        type: groupFields?.isGroup ? 'group' : (groupFields.type || 'single'),
        isGroup: !!groupFields?.isGroup,
        leaveGroup: item?.leaveGroup === true,
        lastMessage: last?.body
            ? {
              _id: lastMessageId,
              content: last?.body,
              senderId,
              timestamp: tsMs,
              ...formatChatTime(tsMs),
              saved: typeof ack === 'number' ? ack >= 1 : true,
              distributed,
              seen,
              deleted: false,
            }
            : null,
        users: [
          {_id: this.currentUserId, username: '我'},
          {_id: roomId, username: roomName || roomId},
        ],
        location: '',
        workingHours: '',
        isPinned: !!item?.pinned,
        isSpecial: false,
        index: tsMs,
        raw: item,
      }
    },

    loadRooms(merge = false) {
      // 首次加载或不分页时重置状态
      if (!merge) {
        this.roomsPagination.offset = 1
        this.roomsTotal = 0
        this.roomsHasMore = true
      }

      // 如果没有更多数据且是加载更多，直接返回
      if (merge && !this.roomsHasMore) {
        return Promise.resolve()
      }

      this.loadingRooms = !merge
      this.loadingMoreRooms = merge
      if (!merge) {
        this.roomsLoaded = false
      }

      const chatId = String(this.roomsPagination.chatId || '').trim()
      const params = {
        filter: {
          ids: chatId ? [chatId] : []
        },
        pagination: {
          limit: this.roomsPagination.limit,
          merge: true,
          offset: this.roomsPagination.offset
        },
        from: this.normalizeFromUsId(this.currentUserId)
      }

      return getAllMessage(params)
          .then((res) => {
            this.resetServiceUnavailable()

            const payload = res?.result || res?.data?.result || res?.data || res
            const total = Number(payload?.total ?? 0)
            if (Number.isFinite(total) && total > 0) {
              this.roomsTotal = total
            }

            const list = this.normalizeGetAllMessagePayload(res)
            const mapped = list
                .map((it) => this.mapChatItemToRoom(it))
                .filter((r) => r.roomId)

            this.applyPinnedFromLocalCache(mapped)

            try {
              const cache = this.readWaUnreadCache()
              mapped.forEach((r) => {
                const key = String(r?.roomId || '')
                if (!key) return
                let cachedCount = 0
                try {
                  const candidates = this.buildPushChatIdCandidates(key)
                  cachedCount = Math.max(
                    0,
                    ...candidates.map((cid) => Number(cache?.[String(cid)] || 0)).filter((n) => Number.isFinite(n))
                  )
                } catch (e) {
                  cachedCount = Number(cache?.[key] || 0)
                }
                if (Number.isFinite(cachedCount) && cachedCount > 0) {
                  r.unreadCount = Math.max(Number(r.unreadCount || 0), cachedCount)
                }

                try {
                  const unread = Number(r.unreadCount || 0)
                  const last = r?.lastMessage
                  if (unread > 0 && last && String(last.senderId || '') !== String(this.currentUserId || '')) {
                    last.seen = false
                  }
                } catch (e) {
                }
              })
            } catch (e) {
            }

            let addedCount = 0

            if (merge) {
              const existingIds = new Set((this.rooms || []).map((r) => String(r?.roomId || '')))
              const toAdd = mapped.filter((r) => !existingIds.has(String(r.roomId)))
              addedCount = toAdd.length
              this.rooms = [...(this.rooms || []), ...toAdd]
            } else {
              addedCount = mapped.length
              this.rooms = mapped
            }

            // 判断是否还有更多数据：后端的 total 可能是“当前页条数/当前页总数”，不能当全量总数使用。
            // 这里使用“本页返回条数 + limit + 是否真正新增”联合判断：
            // - 本页返回 < limit，视为到尾页
            // - 本页返回 >= limit，且确实有新增，才认为还有下一页
            const limit = Number(this.roomsPagination?.limit || 0)
            const pageCount = Array.isArray(mapped) ? mapped.length : 0
            const hasMoreByPage = limit > 0 ? pageCount >= limit : pageCount > 0
            const hasMore = hasMoreByPage && addedCount > 0
            this.roomsHasMore = hasMore
            this.roomsLoaded = !hasMore

            // 更新 offset 为下一页页码（仅在还有更多时自增）
            if (this.roomsHasMore) {
              this.roomsPagination.offset += 1
            }

            this.emitUnreadTotal()
            console.log('[WhatsApp] rooms:', this.rooms, 'hasMore:', this.roomsHasMore)
          })
          .catch((e) => {
            this.markApiFail(e, '会话列表加载失败，服务可能维护中')
            throw e
          })
          .finally(() => {
            this.loadingRooms = false
            this.loadingMoreRooms = false
            // roomsLoaded 在 then/catch 中已根据响应更新，这里不再强制覆盖，避免误判。
          })
    },

    fetchMoreRooms() {
      if (this.loadingMoreRooms || !this.roomsHasMore) return
      this.loadRooms(true)
    },

    //获取当前用户登录信息
    getUserInfo() {
      try {
        const cached = Storage.get('wa_login_user')
        if (cached?.isMock) {
          return
        }

        if (cached?.id) {
          this.currentUserId = String(cached.id)
        }
      } catch (e) {
      }

      return getUserInfoBySession({}, { errorPop: false })
          .then((res) => {
            this.resetServiceUnavailable()
            const payload = res?.result || res?.data?.result || res?.data || res
            const id = payload?.id
            const pushName = payload?.pushName
            const name = payload?.name
            const picture = payload?.picture

            // 使用 name 判断（与 Login.vue 保持一致），pushName 可能为 null
            if (id && name) {
              this.currentUserId = String(id)
              try {
                // 保存完整信息，包括 name 和 picture
                const prev = Storage.get('wa_login_user') || {}
                Storage.set('wa_login_user', {
                  ...prev,
                  id,
                  pushName,
                  name,
                  picture
                })
              } catch (e) {
              }

              // Cache lid<->pn mapping for current user.
              // getUserInfoBySession usually returns id as pn (@c.us). Derive phone and query getLidAndUsByPhone once.
              try {
                const uid = String(id || '')
                const phone = normalizeWaId(uid)
                if (phone && typeof getLidAndUsByPhone === 'function') {
                  const cachedPair = this.getLidPnByPhoneCached(phone)
                  if (!cachedPair?.lid) {
                    getLidAndUsByPhone({ phone })
                      .then((r) => {
                        const result = r?.result || r?.data?.result || null
                        const lid = result?.lid || ''
                        const pn = result?.pn || ''
                        if (lid && pn) this.upsertWaJidPair({ lid, pn })
                      })
                      .catch(() => {})
                  }
                }
              } catch (e) {
              }
            }

            // 只有明确没有 id 或 name 时才认为是未登录，清除数据并跳转
            if (!id || !name) {
              try {
                Storage.remove('wa_login_user')
              } catch (e) {
              }
              this.$router.replace('/whatsapp/walogin')
            }
          })
          .catch((e) => {
            this.markApiFail(e, '用户信息获取失败，服务可能维护中')
          })
    },

    async addRoom(val) {
      const rawInput = typeof val === 'object' && val ? String(val?.phone || '').trim() : String(val || '').trim()
      const contactInfo = typeof val === 'object' && val ? (val?.contact || null) : null
      const input = rawInput
      if (!input) return

      if (this.validatingSingleChat) return
      this.validatingSingleChat = true

      // 创建临时 room 前，先校验手机号对应的账户是否存在。
      // 后端会返回：{ lid: "xxx@lid", pn: "8613...@c.us" }
      // 这里应使用 lid（即 @lid jid）作为真正的 chatId。
      let lid = ''
      let pn = ''

      // 先查缓存：如果已有 pn->lid 映射，就不必请求 getLidAndUsByPhone
      try {
        const cached = this.getLidPnByPhoneCached(input)
        if (cached?.lid) {
          lid = cached.lid
          pn = cached.pn
        }
      } catch (e) {
      }

      if (lid && pn) {
        try {
          await this.openOrCreateSingleChatByLidPn({ input, lid, pn, contactInfo })
        } finally {
          this.validatingSingleChat = false
        }
        return
      }

      try {
        const res = await getLidAndUsByPhone({phone: input})
        const result = res?.result || res?.data?.result || null
        lid = result?.lid || ''

        // pn 作为兼容匹配（有些历史 room 可能使用 @c.us 作为 roomId）
        pn = result?.pn || ''

        // cache lid<->pn mapping
        try {
          if (lid && pn) {
            this.upsertWaJidPair({ lid, pn })
          }
        } catch (e) {
        }

        if (!lid) {
          this.$message?.warning?.('该手机号未注册 WhatsApp 或不可用')
          return
        }
      } catch (e) {
        this.$message?.error?.(e?.message || '校验手机号失败')
        return
      } finally {
        this.validatingSingleChat = false
      }

      await this.openOrCreateSingleChatByLidPn({ input, lid, pn, contactInfo })
    },

    async fetchMessages({ room, options } = {}) {
      const opt = options || {}
      const reset = !!opt.reset
      const chatId = String(room?.roomId || '')

      // 请求去重：页面刷新/初始化时可能会重复触发同一个 room 的首次拉取。
      // 不改变现有业务触发逻辑，只在“同 chatId 的首屏(reset)请求仍在飞行中”时复用 Promise，避免重复打接口。
      const willReset = reset || this.messagesPagination.chatId !== chatId
      const dedupeKey = willReset ? `reset:${chatId}` : `more:${chatId}:${this.messagesPagination.offset}:${this.messagesPagination.messageId}`
      if (willReset && this._fetchMessagesInFlight && this._fetchMessagesInFlight.key === dedupeKey && this._fetchMessagesInFlight.promise) {
        return this._fetchMessagesInFlight.promise
      }

      // 竞态防护：快速切换 room 时，旧请求返回不能覆盖新 room 的消息
      // 使用递增 token 标记本次请求，只有最新 token 且 roomId 未变更时才允许落地
      if (!this._fetchMessagesToken) this._fetchMessagesToken = 0
      const currentToken = ++this._fetchMessagesToken
      const requestedChatId = chatId

      // 临时 room：不需要拉取聊天详情（不调用 getMessageByChatId）
      if (room?.isTemp || (chatId && String(chatId).startsWith('temp_'))) {
        this.activeRoomId = ''
        this.messages = []
        this.messagesLoaded = true
        return
      }

      this.activeRoomId = chatId || ''
      this.messagesLoaded = false

      if (reset) {
        try {
          const r = (this.rooms || []).find((rr) => rr && String(rr.roomId || '') === String(chatId || ''))
          if (r) {
            r.unreadCount = 0
            this.rooms = [...(this.rooms || [])]
            this.emitUnreadTotal()

            try {
              const cache = this.readWaUnreadCache()
              const key = String(chatId || '')
              if (key && Object.prototype.hasOwnProperty.call(cache, key)) {
                delete cache[key]
                this.writeWaUnreadCache(cache)
              }
            } catch (e) {
            }
          }
        } catch (e) {
        }
      }

      if (!chatId) {
        this.messages = []
        this.messagesLoaded = true
        return
      }

      const apiChatId = (() => {
        const raw = String(chatId || '').trim()
        if (!raw) return ''
        if (raw.includes('@')) {
          const m = raw.match(/^([^@]+)@/)
          const local = m ? String(m[1] || '') : ''
          if (!local) return ''
          // backend 会对 chatId 做 parseInt，非数字 local-part 会直接导致 500
          if ((raw.endsWith('@lid') || raw.endsWith('@c.us') || raw.endsWith('@g.us')) && !/^\d+$/.test(local)) {
            return ''
          }
          return raw
        }
        if (/^\d+$/.test(raw)) return this.normalizeSingleChatId(raw)
        return ''
      })()

      if (!apiChatId) {
        this.messages = []
        this.messagesLoaded = true
        try {
          if (this.isDev) {
            console.warn('[WhatsApp] invalid chatId for getMessageByChatId:', chatId)
          }
        } catch (e) {
        }
        return Promise.resolve()
      }

      // reset: 切换房间 / 首次加载
      if (willReset) {
        this.messagesPagination = {
          ...this.messagesPagination,
          chatId,
          offset: 1,
          messageId: ''
        }
        this.messages = []
        // 不确定是否还有更多历史时：先认为还有，直到接口返回 < limit
        this.messagesLoaded = false
      }

      // 竞态场景下：上一个 room 的请求可能仍在飞。
      // 切换 room 时（reset=true），必须允许新请求发出，否则会出现“请求根本发不出去”。
      // 非 reset（上滑加载更多）时，才维持单次 in-flight 限制。
      if (!reset && this.loadingMoreMessages) return
      this.loadingMoreMessages = true
      this._loadingMoreMessagesToken = currentToken

      const params = {
        chatId: apiChatId,
        from: this.normalizeFromUsId(this.currentUserId),
        downloadMedia: this.messagesPagination.downloadMedia,
        ...(this.messagesPagination.filterAck ? {filterAck: this.messagesPagination.filterAck} : {}),
        ...(this.messagesPagination.filterFromMe === '' || this.messagesPagination.filterFromMe === null || typeof this.messagesPagination.filterFromMe === 'undefined'
            ? {}
            : {filterFromMe: this.messagesPagination.filterFromMe}),
        limit: this.messagesPagination.limit,
        merge: this.messagesPagination.merge,
        messageId: this.messagesPagination.messageId,
        offset: this.messagesPagination.offset,
        sortBy: this.messagesPagination.sortBy,
        sortOrder: this.messagesPagination.sortOrder
      }

      const reqPromise = getMessageByChatId(params)
          .then((res) => {
            // 旧请求返回：直接丢弃
            if (currentToken !== this._fetchMessagesToken) return
            // room 已切换：直接丢弃
            if (String(this.activeRoomId || '') !== String(requestedChatId || '')) return

            const list = this.normalizeGetMessageByChatIdPayload(res)
            const mapped = (list || [])
                .map((m) => this.mapApiMessageToUiMessage(m, room))
                .filter(Boolean)
                // 过滤掉无内容且无媒体的消息，避免空白气泡
                .filter((m) => m && m._id && (m.content || m.hasMedia || (m.files && m.files.length)))

            // 更新消息缓存（用于 replyTo -> replyMessage）
            try {
              mapped.forEach((m) => {
                if (!m?._id) return
                this.messageIndex[String(m._id)] = m
              })
            } catch (e) {
            }

            // 后端返回顺序不保证，统一按时间正序
            mapped.sort((a, b) => (a.timestamp || 0) - (b.timestamp || 0))

            // offset 模式：请求的是更老的一页，需要 prepend 到顶部
            this.messages = this.mergeMessagesPrepend(this.messages, mapped)

            if (reset && chatId && this._hasUserInteracted) {
              this.queueSeenForRoom(chatId)
            }

            // 没有更多：返回条数 < limit（limit=0 时认为一次性拉完）
            const limit = Number(this.messagesPagination.limit) || 0
            const noMore = limit === 0 ? true : mapped.length < limit
            this.messagesLoaded = noMore

            // 更新分页页码（仅在还有更多时自增）
            if (!noMore) {
              this.messagesPagination.offset += 1
            }


            // 在 /message/getMessageByChatId 成功之后，再拉取联系人信息
            try {
              if (reset && typeof getContactInfoByContactId === 'function') {
                const rid = String(chatId || '')
                const isGroup = rid.includes('@g.us') || room?.isGroup === true || room?.type === 'group'
                if (rid && !isGroup) {
                  if (this.contactInfoCacheByRoomId?.[rid]) {
                    this.applyContactInfoToRoom(rid, this.contactInfoCacheByRoomId[rid])
                  } else {
                    const from = this.normalizeFromUsId(this.currentUserId)
                    getContactInfoByContactId({ contactId: rid, from })
                      .then((r2) => {
                        const info = r2?.result || r2?.data?.result || null
                        if (!info) return
                        this.contactInfoCacheByRoomId = {
                          ...(this.contactInfoCacheByRoomId || {}),
                          [rid]: info
                        }
                        // 防止并发切换 room 后写错
                        if (String(this.activeRoomId || '') !== String(rid || '')) return
                        this.applyContactInfoToRoom(rid, info)
                      })
                      .catch(() => {
                      })
                  }
                }
              }
            } catch (e) {
            }
          })
          .catch((e) => {
            if (currentToken !== this._fetchMessagesToken) return
            if (String(this.activeRoomId || '') !== String(requestedChatId || '')) return
            this.markApiFail(e, '消息加载失败，服务可能维护中')
          })
          .finally(() => {
            // 只允许最新请求关闭 loading，避免旧请求影响新 room 的 loading 状态
            if (currentToken !== this._fetchMessagesToken) return
            if (String(this.activeRoomId || '') !== String(requestedChatId || '')) return
            if (this._loadingMoreMessagesToken && this._loadingMoreMessagesToken !== currentToken) return
            this.loadingMoreMessages = false
          })

      if (willReset) {
        this._fetchMessagesInFlight = { key: dedupeKey, promise: reqPromise }
        reqPromise.finally(() => {
          if (this._fetchMessagesInFlight && this._fetchMessagesInFlight.key === dedupeKey) {
            this._fetchMessagesInFlight = null
          }
        })
      }

      return reqPromise
    },

    queueSeenForRoom(chatId) {
      const cid = String(chatId || '')
      if (!cid) return
      if (typeof sendSeen !== 'function') return

      const list = (this.messages || [])
      const ids = []
      let participant = ''

      for (let i = list.length - 1; i >= 0; i--) {
        const m = list[i]
        if (!m || !m._id) continue
        if (m.senderId === this.currentUserId) continue
        if (m.__seenQueued === true) continue
        m.__seenQueued = true
        ids.push(String(m._id))
        if (!participant) {
          const raw = m?.raw
          const d = raw?._data || raw || {}
          participant = d?.author?._serialized || d?.participant?._serialized || d?.from?._serialized || ''
        }
        if (ids.length >= 50) break
      }

      if (ids.length === 0) return

      if (!this.pendingSeen[cid]) {
        this.pendingSeen[cid] = {messageIds: new Set(), participant: ''}
      }
      const bucket = this.pendingSeen[cid]
      ids.forEach((x) => bucket.messageIds.add(x))
      if (!bucket.participant && participant) bucket.participant = participant

      const r = (this.rooms || []).find((rr) => rr && String(rr.roomId) === cid)
      if (r) {
        r.unreadCount = 0
        this.emitUnreadTotal()

        try {
          const cache = this.readWaUnreadCache()
          if (cid && Object.prototype.hasOwnProperty.call(cache, cid)) {
            delete cache[cid]
            this.writeWaUnreadCache(cache)
          }
        } catch (e) {
        }
      }

      this.flushSeenDebounced()
    },

    flushSeenDebounced() {
      if (this.pendingSeenTimer) return
      this.pendingSeenTimer = setTimeout(() => {
        this.pendingSeenTimer = null
        this.flushSeen()
      }, 500)
    },

    flushSeen() {
      if (this.sendingSeen) return
      const cid = String(this.activeRoomId || '')
      if (!cid) return
      const bucket = this.pendingSeen?.[cid]
      if (!bucket || !bucket.messageIds || bucket.messageIds.size === 0) return

      const messageIds = Array.from(bucket.messageIds)
      bucket.messageIds.clear()

      this.sendingSeen = true
      const session = 'default'

      const payload = {
        chatId: cid,
        messageIds,
        ...(bucket.participant ? {participant: bucket.participant} : {}),
        session
      }

      return sendSeen(payload)
          .catch(() => {
          })
          .finally(() => {
            this.sendingSeen = false
          })
    },

    sendMessage(payload) {
      const isTempRoom = !!(
          payload?.roomId &&
          String(payload.roomId).startsWith('temp_') &&
          this.tempRoom &&
          String(this.tempRoom.roomId) === String(payload.roomId)
      )

      const actualChatId = isTempRoom ? String(this.tempRoom?.targetChatId || '') : String(payload?.roomId || '')
      if (isTempRoom && !actualChatId) {
        this.$message?.warning?.('缺少 chatId，无法发送')
        return
      }

      const resolveToken = isTempRoom ? ++this._tempRoomResolveToken : 0
      const tempTargetIds = isTempRoom
          ? (Array.isArray(this.tempRoom?.targetChatIds) && this.tempRoom.targetChatIds.length
              ? this.tempRoom.targetChatIds
              : [actualChatId])
          : []

      const ts = Date.now();
      const replyMessage = payload?.replyMessage || null
      const replyTo = replyMessage?._id ? String(replyMessage._id) : ''
      const hasFiles = !!(payload?.files && payload.files.length > 0)
      const msg = {
        ...payload,
        roomId: actualChatId,
        _id: `msg_${ts}`,
        senderId: this.currentUserId,
        username: "我",
        timestamp: ts,
        ...formatChatTime(ts),
        saved: !hasFiles,
        distributed: false,
        seen: false,
        deleted: false,
        sending: hasFiles,
        reactions: {},
        ...(replyMessage ? {replyMessage} : {}),
        ...(replyTo ? {replyTo} : {}),
      };
      this.messages.push(msg);

      // 写入缓存，确保后续根据 replyTo 能还原 replyMessage
      try {
        this.messageIndex[String(msg._id)] = msg
      } catch (e) {
      }

      const room = this.rooms.find((r) => String(r.roomId) === String(actualChatId));
      if (room) {
        room.lastMessage = {...msg};
        room.lastMessageTimestamp = msg.timestamp;
        room.index = msg.timestamp;
        room.unreadCount = 0;
      }

      if (!hasFiles) {
        setTimeout(() => {
          msg.distributed = true;
        }, 1000);
      }

      // 调用后端接口发送
      const chatId = actualChatId; // roomId 即 chatId
      const session = 'default';

      const replyMsg = payload?.replyMessage
      const replyMsgType = replyMsg?.type || replyMsg?.raw?._data?.type
      const isReply = !!replyMsg?._id
      const isButtonsReply = !!replyMsg?._id && (
          replyMsgType === 'buttons' ||
          replyMsgType === 'template_button_reply' ||
          replyMsgType === 'buttons_response' ||
          replyMsgType === 'list' ||
          replyMsgType === 'list_response'
      )

      if (payload?.files && payload.files.length > 0) {
        const f = payload.files[0] || {};

        const filename = f.name || f.filename || 'file'
        const mimetype = f.type || f.mimetype || 'application/octet-stream'
        const isImage = typeof mimetype === 'string' && mimetype.startsWith('image/')

        // 文件已经在 RoomFooter 中上传完成，直接使用 url
        if (!f.url) {
          this.$message?.error?.('文件尚未上传完成，请稍后再试')
          return
        }

        const apiCall = isImage ? sendImage : sendFile

        return apiCall({
          caption: payload.content || '',
          chatId,
          file: {
            filename,
            mimetype,
            url: f.url
          },
          ...(payload.replyMessage?._id ? {replyTo: payload.replyMessage._id} : {}),
          session
        })
            .then((res) => {
              msg.saved = true
              msg.distributed = true
              msg.failure = false
              msg.sending = false
              this.messages = [...this.messages]

              try {
                const payload0 = res?.result || res?.data?.result || res?.data || res || {}
                const messageId = String(
                    payload0?._data?.id?._serialized ||
                    payload0?.id?._serialized ||
                    payload0?._data?.id ||
                    payload0?.messageId ||
                    payload0?.id ||
                    payload0?._id ||
                    ''
                )

                let userName = ''
                try {
                  userName = String((Storage.get('wa_login_user') || {})?.name || '')
                } catch (e) {
                }

                let extendType = 2
                if (typeof mimetype === 'string') {
                  if (mimetype.startsWith('image/') || mimetype.startsWith('video/') || mimetype.startsWith('audio/')) {
                    extendType = 1
                  }
                }

                const userId = String((Storage.get('userInfo') || {})?.id || '')

                addWhatsAppExtend({
                  chatId: String(chatId || ''),
                  messageId,
                  name: String(filename || ''),
                  type: extendType,
                  url: String(f.url || ''),
                  extendSize: Number(f.size || 0),
                  userId,
                  userName
                }).catch((e) => {
                  this.$message?.warning?.(e?.message || '附件存储失败')
                })
              } catch (e) {
              }

              const r = this.rooms.find((rr) => rr && rr.roomId === chatId)
              if (r) {
                r.lastMessage = {...msg}
                r.lastMessageTimestamp = msg.timestamp
                r.index = msg.timestamp
                r.unreadCount = 0
              }
            })
            .catch((e) => {
              msg.failure = true
              msg.sending = false
              this.messages = [...this.messages]
              this.$message?.error?.(e?.message || (isImage ? '发送图片失败' : '发送文件失败'))
              throw e
            })
            .finally(() => {
              if (isTempRoom) {
                this.resolveTempRoomAfterFirstSend({preferredChatIds: tempTargetIds, token: resolveToken})
              }
            })
      } else {
        if (isButtonsReply) {
          const selectedDisplayText = payload.content || ''
          const d = replyMsg?.raw?._data || {}
          const normalizedTarget = String(selectedDisplayText || '').trim().toLowerCase()

          const collectOptions = () => {
            const options = []

            const buttons = Array.isArray(d?.buttons) ? d.buttons : null
            if (buttons) {
              buttons.forEach((b, idx) => {
                if (!b) return
                const id = b?.buttonId || b?.id || b?.reply?.id || b?.reply?.buttonId || `button_${idx + 1}`
                const text = b?.buttonText?.displayText || b?.text || b?.title || b?.reply?.title || ''
                options.push({id: String(id), text: String(text)})
              })
            }

            const listSections = d?.list?.sections || d?.sections || d?.interactive?.action?.sections
            if (Array.isArray(listSections)) {
              listSections.forEach((sec) => {
                const rows = sec?.rows
                if (!Array.isArray(rows)) return
                rows.forEach((r) => {
                  if (!r) return
                  const id = r?.rowId || r?.id || r?.reply?.id
                  const text = r?.title || r?.text || r?.description || ''
                  if (id || text) options.push({id: String(id || ''), text: String(text)})
                })
              })
            }

            return options.filter((o) => o && o.id)
          }

          const options = collectOptions()
          let selectedButtonID = ''
          if (normalizedTarget && options.length) {
            const hit = options.find((o) => String(o.text || '').trim().toLowerCase() === normalizedTarget)
            if (hit?.id) selectedButtonID = hit.id
          }
          if (!selectedButtonID && options.length) {
            selectedButtonID = options[0].id
          }
          if (!selectedButtonID) {
            selectedButtonID = 'button_1'
          }

          sendButtonsReply({
            chatId,
            replyTo: replyMsg._id,
            selectedButtonID,
            selectedDisplayText,
            session
          }).catch((e) => {
            this.$message?.error?.(e?.message || '发送按钮回复失败')
          })
        } else if (isReply) {
          // 只要是"回复某条消息"的发送，都走 sendButtonsReply（后端强制要求 selectedButtonID/selectedDisplayText）
          sendButtonsReply({
            chatId,
            linkPreview: true,
            linkPreviewHighQuality: false,
            replyTo: replyMsg._id,
            selectedButtonID: 'button_1',
            selectedDisplayText: payload.content || '',
            session,
            text: payload.content || ''
          }).catch((e) => {
            this.$message?.error?.(e?.message || '发送回复失败')
          })
        } else {
          // 非回复场景：仍然走普通文本发送
          const extractFirstValidUrl = (text) => {
            const raw = String(text || '').trim()
            if (!raw) return ''

            const urlRegex = /(https?:\/\/[^\s]+)|(www\.[^\s]+)/ig
            const candidates = raw.match(urlRegex) || []
            if (!candidates.length) return ''

            const trimPunctuation = (u) => {
              let s = String(u || '').trim()
              if (!s) return ''
              // remove common trailing punctuation / brackets when user pasted url in a sentence
              while (/[\]\[\)\(\}\{<>.,!?;:'"，。！？；：”’》】）]+$/.test(s)) {
                s = s.replace(/[\]\[\)\(\}\{<>.,!?;:'"，。！？；：”’》】）]+$/, '')
              }
              return s
            }

            const normalize = (u) => {
              const s = trimPunctuation(u)
              if (!s) return ''
              if (/^www\./i.test(s)) return `https://${s}`
              return s
            }

            const isValidHttpUrl = (u) => {
              try {
                const urlObj = new URL(u)
                return urlObj.protocol === 'http:' || urlObj.protocol === 'https:'
              } catch (e) {
                return false
              }
            }

            for (const c of candidates) {
              const u = normalize(c)
              if (u && isValidHttpUrl(u)) return u
            }
            return ''
          }

          const text0 = String(payload?.content || '').trim()
          const url = extractFirstValidUrl(text0)

          const sendPromise = url
            ? sendLinkCustomPreview({
              chatId,
              linkPreviewHighQuality: true,
              preview: {
                description: text0,
                title: url,
                url
              },
              session,
              text: text0
            })
            : sendText({
              chatId,
              linkPreview: true,
              linkPreviewHighQuality: false,
              session,
              text: text0
            })

          sendPromise
            .then((res) => {
              try {
                if (url) {
                  const payload0 = res?.result || res?.data?.result || res?.data || res || {}
                  const messageId = String(
                    payload0?._data?.id?._serialized ||
                    payload0?.id?._serialized ||
                    payload0?._data?.id ||
                    payload0?.messageId ||
                    payload0?.id ||
                    payload0?._id ||
                    ''
                  )

                  let userName = ''
                  try {
                    userName = String((Storage.get('wa_login_user') || {})?.name || '')
                  } catch (e) {
                  }
                  const userId = String((Storage.get('userInfo') || {})?.id || '')
                  addWhatsAppExtend({
                    chatId: String(chatId || ''),
                    messageId,
                    name: url,
                    type: 3,
                    url,
                    extendSize: 0,
                    userId,
                    userName
                  }).catch((e) => {
                    this.$message?.warning?.(e?.message || '链接存储失败')
                  })
                }
              } catch (e) {
              }

              if (isTempRoom) {
                return this.resolveTempRoomAfterFirstSend({preferredChatIds: tempTargetIds, token: resolveToken})
              }
            })
            .catch(() => {
            })
        }
      }
    },

    sendVoice(payload) {
      const ts = Date.now();
      const replyMessage = payload?.replyMessage || null
      const replyTo = replyMessage?._id ? String(replyMessage._id) : ''

      // 构造语音消息（乐观更新）
      const msg = {
        _id: `voice_${ts}`,
        senderId: this.currentUserId,
        username: "我",
        timestamp: ts,
        ...formatChatTime(ts),
        content: '[语音]',
        saved: false,
        distributed: false,
        seen: false,
        deleted: false,
        sending: true,
        reactions: {},
        files: [{
          url: payload.url,
          type: payload.mimetype || 'audio/mpeg',
          name: 'audio',
          extension: payload.filename?.split('.').pop() || 'mp3',
          duration: payload.duration,
          audio: true
        }],
        ...(replyMessage ? {replyMessage} : {}),
        ...(replyTo ? {replyTo} : {}),
      };
      this.messages.push(msg);

      // 写入缓存
      try {
        this.messageIndex[String(msg._id)] = msg
      } catch (e) {
      }

      // 更新房间 lastMessage
      const room = this.rooms.find((r) => r.roomId === payload.roomId);
      if (room) {
        room.lastMessage = {...msg};
        room.lastMessageTimestamp = msg.timestamp;
        room.index = msg.timestamp;
        room.unreadCount = 0;
      }

      // 调用 sendVoice API 发送语音
      const chatId = payload.roomId;
      const session = 'default';

      return sendVoice({
        chatId,
        convert: true,
        file: {
          filename: payload.filename || 'audio.mp3',
          mimetype: payload.mimetype || 'audio/mpeg',
          url: payload.url
        },
        ...(replyTo ? {replyTo} : {}),
        session
      })
          .then((res) => {
            msg.saved = true
            msg.distributed = true
            msg.failure = false
            msg.sending = false
            this.messages = [...this.messages]

            try {
              const payload0 = res?.result || res?.data?.result || res?.data || res || {}
              const messageId = String(
                  payload0?._data?.id?._serialized ||
                  payload0?.id?._serialized ||
                  payload0?._data?.id ||
                  payload0?.messageId ||
                  payload0?.id ||
                  payload0?._id ||
                  ''
              )

              let userName = ''
              try {
                userName = String((Storage.get('wa_login_user') || {})?.name || '')
              } catch (e) {
              }

              const userId = String((Storage.get('userInfo') || {})?.id || '')

              addWhatsAppExtend({
                chatId: String(chatId || ''),
                messageId,
                name: String(payload.filename || 'audio.mp3'),
                type: 1,
                url: String(payload.url || ''),
                extendSize: Number(payload?.size || payload?.fileSize || msg?.files?.[0]?.size || 0),
                userId,
                userName
              }).catch((e) => {
                this.$message?.warning?.(e?.message || '附件存储失败')
              })
            } catch (e) {
            }

            const r = this.rooms.find((rr) => rr && rr.roomId === chatId)
            if (r) {
              r.lastMessage = {...msg}
              r.lastMessageTimestamp = msg.timestamp
              r.index = msg.timestamp
              r.unreadCount = 0
            }
          })
          .catch((e) => {
            msg.failure = true
            msg.sending = false
            this.messages = [...this.messages]
            this.$message?.error?.(e?.message || '发送语音失败')
            throw e
          })
    },

    deleteMessage({message, roomId}) {
      const chatId = roomId;
      const messageId = message?._id || message?.id;
      if (!chatId || !messageId) {
        this.$message?.error?.('缺少必要的参数');
        return;
      }

      deleteMessageByMessageId({chatId, messageId})
          .catch((e) => {
            // 删除失败时回滚：把消息加回来
            if (message) {
              this.messages = [...this.messages, message].sort((a, b) => a.timestamp - b.timestamp);
            }
            this.$message?.error?.(e?.message || '删除消息失败');
          });

      // 前端立即删除，无感体验
      this.messages = this.messages.filter((m) => m._id !== messageId);
    },

    editMessage({messageId, newContent, files, roomId}) {
      const chatId = roomId;
      if (!chatId || !messageId || !newContent) {
        this.$message?.error?.('缺少必要的参数');
        return;
      }

      // 前端立即更新，无感编辑体验
      const message = this.messages.find((m) => m._id === messageId);
      const oldContent = message?.content;
      if (message) {
        message.content = newContent;
        // 触发响应式更新
        this.messages = [...this.messages];
      }

      // 调用后端接口
      updateMessageByMessageId({chatId, messageId, text: newContent})
          .catch((e) => {
            // 编辑失败时回滚
            if (message && oldContent) {
              message.content = oldContent;
              this.messages = [...this.messages];
            }
            this.$message?.error?.(e?.message || '编辑消息失败');
          });
    },

    // 🔥 处理设计稿中的菜单操作
    roomActionHandler({action, roomId}) {
      const chatId = String(roomId || '')
      if (!chatId) return

      const room = (this.rooms || []).find((r) => String(r.roomId || '') === chatId)

      switch (action.name) {
        case "archive":
          if (!room) return;
          try {
            const isArchived = !!room?.contactInfo?.isMyCustomer
            if (isArchived) return
          } catch (e) {
          }

          const openArchiveDrawer = () => {
            // 归档对话：切换右侧抽屉到归档模式，抽屉会负责把 roomId 清洗后传入 ReturnEmails(npId)
            if (this.$refs.chatComponent?.handleClickShowRight) {
              this.$refs.chatComponent.handleClickShowRight('archive')
            }
          }

          // 若缓存未命中，需要先拉一次联系人信息来判断是否已归档
          if (this.contactInfoCacheByRoomId?.[chatId]) {
            try {
              this.applyContactInfoToRoom(chatId, this.contactInfoCacheByRoomId[chatId])
            } catch (e) {
            }
            const nextRoom = (this.rooms || []).find((r) => String(r?.roomId || '') === chatId) || room
            if (nextRoom?.contactInfo?.isMyCustomer) return
            openArchiveDrawer()
            return
          }

          try {
            const from = this.normalizeFromUsId(this.currentUserId)
            getContactInfoByContactId({ contactId: chatId, from })
              .then((r2) => {
                const info = r2?.result || r2?.data?.result || null
                if (info) {
                  this.contactInfoCacheByRoomId = {
                    ...(this.contactInfoCacheByRoomId || {}),
                    [chatId]: info
                  }
                  this.applyContactInfoToRoom(chatId, info)
                  const nextRoom = (this.rooms || []).find((r) => String(r?.roomId || '') === chatId) || room
                  if (nextRoom?.contactInfo?.isMyCustomer) return
                }
                openArchiveDrawer()
              })
              .catch(() => {
                openArchiveDrawer()
              })
          } catch (e) {
            openArchiveDrawer()
          }
          break;
        case "leaveGroup":
          this.$refs.leaveGroupConfirm.open(chatId)
          break;
        case "pin":
          if (!room) return;
          this.toggleRoomPin(room)
              .then(() => {
                console.log("置顶对话:", roomId, room.isPinned);
              })
              .catch(() => {
              })
          break;
        case "mark":
          console.log("标记记录:", roomId);
          break;
        case "special":
          if (!room) return;
          room.isSpecial = !room.isSpecial;
          console.log("特别关注:", roomId, room.isSpecial);
          break;
        case "delete":
          // 打开删除确认对话框
          this.$refs.deleteChatConfirm.open(chatId);
          break;
        case "clearChat":
          this.$refs.clearChatConfirm.open(chatId);
          break;
        default:
          break;
      }
    },

    // 关闭当前对话
    handleCloseRoom() {
      this.clearAllTypingTimers()
      this.activeRoomId = "";
      this.tempRoom = null
      this.messages = [];
    },

    handleDeleteRoom(roomId) {
      // 从房间列表中移除
      this.rooms = this.rooms.filter((r) => r.roomId !== roomId);

      // 如果删除的是当前正在查看的房间，清空选中状态显示 "No room selected"
      if (this.activeRoomId === roomId) {
        this.messages = [];
        this.activeRoomId = "";
      }
    },

    // 处理消息表情反应
    handleMessageReaction({messageId, reaction, remove, roomId}) {
      const message = this.messages.find((m) => m._id === messageId);
      if (!message) return;

      // 确保 reactions 对象存在
      if (!message.reactions) {
        message.reactions = {};
      }

      const emojiUnicode = reaction.unicode;

      // 调用后端接口
      sendReaction({
        messageId,
        reaction: remove ? '' : emojiUnicode,
        session: 'default'
      }).catch(() => {
      });

      if (remove) {
        // 移除表情：从该表情的用户列表中移除当前用户
        if (message.reactions[emojiUnicode]) {
          const index = message.reactions[emojiUnicode].indexOf(this.currentUserId);
          if (index !== -1) {
            message.reactions[emojiUnicode].splice(index, 1);
          }
          // 如果该表情没有用户了，删除该表情键
          if (message.reactions[emojiUnicode].length === 0) {
            delete message.reactions[emojiUnicode];
          }
        }
      } else {
        // 添加表情：将当前用户添加到该表情的用户列表中
        if (!message.reactions[emojiUnicode]) {
          message.reactions[emojiUnicode] = [];
        }
        // 避免重复添加
        if (!message.reactions[emojiUnicode].includes(this.currentUserId)) {
          message.reactions[emojiUnicode].push(this.currentUserId);
        }
      }

      // 触发响应式更新
      this.messages = [...this.messages];
    },

    // 处理输入状态（typing）
    handleTypingMessage({message, roomId}) {
      const chatId = roomId; // roomId 即 chatId
      const session = 'default';

      const now = Date.now()
      const startMinIntervalMs = 2000
      const stopDebounceMs = 2500

      if (!this.typingStates[roomId]) {
        const lastAt = Number(this.typingLastStartAt[roomId] || 0)
        if (now - lastAt >= startMinIntervalMs) {
          this.typingStates[roomId] = true
          this.typingLastStartAt[roomId] = now
          startTyping({chatId, session}).catch(() => {
          });
        }
      }

      // 清除之前的定时器
      if (this.typingTimers[roomId]) {
        clearTimeout(this.typingTimers[roomId]);
      }

      // stopTyping 防抖：持续输入会一直延后停止通知
      this.typingTimers[roomId] = setTimeout(() => {
        this.typingStates[roomId] = false
        stopTyping({chatId, session}).catch(() => {
        });
      }, stopDebounceMs);
    },
  },
};
</script>

<style scoped lang="scss">
/* 可选：自定义灰色占位头像样式 */
.vac-avatar:empty {
  background-color: #e0e0e0 !important;
  border-radius: 50%;
}

:deep(.el-alert__title) {
  line-height: 0px !important;
}
</style>